/* ParfymDupe – Hitta din parfym v3.6 – mobilknappar med fritt utrymme ovanför Belöningar
 * Inga API-nycklar, externa bibliotek, kakor eller lagrade testsvar.
 * Rekommendationer är en transparent, viktad rangordning av butikens data.
 * Produktbeskrivningar analyseras INTE för att gissa saknade egenskaper.
 */
(function () {
  'use strict';

  const VERSION = 'pd-finder-v1';
  const TTL = 5 * 60 * 1000;
  const QUIZ_BATCH_SIZE = 3;
  const QUIZ_MAX_RESULTS = 9;
  // Urvalsgränser ENDAST för extra kort. Befintliga topp tre och doftpoäng ändras inte.
  // Detta är produktregler, inte vetenskapligt validerade sannolikheter.
  const EXTRA_MIN_SCORE = 0.5;
  const EXTRA_MIN_COVERAGE = 0.6;
  const sampleCache = new Map();
  const cache = new Map(); // Endast minne, töms när sidan lämnas/laddas om.
  const CDN = 'https://cdn.shopify.com/s/files/1/0895/0389/1781/files/';
  const GROUPS = [
    {
      "id": "fresh",
      "label": "Fräscht & rent",
      "desc": "Citrus, grönt och en ren känsla.",
      "image": "parfymtest-frascht-rent.png?v=1789508288",
      "alt": "Citrusfrukter, mynta och vattenstänk framför vitt tyg.",
      "profiles": [
        "Fräsch",
        "Frisk",
        "Ren",
        "Citrusig",
        "Grön",
        "Akvatisk",
        "Aquatisk",
        "Marin",
        "Tvålig"
      ],
      "notes": [
        "Bergamott",
        "Citron",
        "Lime",
        "Grapefrukt",
        "Mynta",
        "Petitgrain",
        "Grönt te"
      ]
    },
    {
      "id": "floral",
      "label": "Blommigt",
      "desc": "Mjuka blommor, jasmin och ros.",
      "image": "parfymtest-blommigt.png?v=1789508372",
      "alt": "Rosa rosor och pioner med små vita blommor och daggdroppar.",
      "profiles": [
        "Blommig",
        "Rosig"
      ],
      "notes": [
        "Ros",
        "Jasmin",
        "Pion",
        "Tuberos",
        "Apelsinblomma",
        "Viol",
        "Ylang-ylang",
        "Iris"
      ]
    },
    {
      "id": "fruit",
      "label": "Fruktigt",
      "desc": "Saftiga frukter och söta bär.",
      "image": "parfymtest-fruktigt.png?v=1789508462",
      "alt": "Päron, persika, äpple, mango och bär på en ljus stenyta.",
      "profiles": [
        "Fruktig",
        "Körsbärsfruktig",
        "Bärig"
      ],
      "notes": [
        "Äpple",
        "Grönt äpple",
        "Persika",
        "Päron",
        "Hallon",
        "Jordgubb",
        "Körsbär",
        "Litchi",
        "Mango",
        "Ananas",
        "Passionsfrukt"
      ]
    },
    {
      "id": "vanilla",
      "label": "Vanilj",
      "desc": "Mjuk, varm och vaniljig.",
      "image": "parfymtest-vanilj.png?v=1789508473",
      "alt": "Vaniljstänger, ljusa orkidéblommor och en skål med kräm i varmt ljus.",
      "profiles": [
        "Vaniljig"
      ],
      "notes": [
        "Vanilj",
        "Bourbonvanilj",
        "Madagaskarvanilj",
        "Vaniljorkidé",
        "Vaniljstång"
      ]
    },
    {
      "id": "gourmand",
      "label": "Sött & gourmand",
      "desc": "Dessert, karamell och choklad.",
      "image": "parfymtest-sott-gourmand.png?v=1789508487",
      "alt": "Karamell, choklad, praliner, marshmallows och vispad kräm.",
      "profiles": [
        "Gourmand",
        "Godislik",
        "Chokladig",
        "Karamellig",
        "Honungig",
        "Nötig",
        "Sockersöt"
      ],
      "notes": [
        "Karamell",
        "Choklad",
        "Kakao",
        "Honung",
        "Marshmallow",
        "Pralin",
        "Pistage",
        "Sockervadd"
      ]
    },
    {
      "id": "powder",
      "label": "Pudrigt & mjukt",
      "desc": "Pudrig elegans och mjuk iris.",
      "image": "parfymtest-pudrigt-mjukt.png?v=1789508498",
      "alt": "Ljuslila irisblommor, en skål med puder och mjukt ljust tyg.",
      "profiles": [
        "Pudrig",
        "Powdery"
      ],
      "notes": [
        "Iris",
        "Irisrot",
        "Orris",
        "Viol",
        "Heliotrop"
      ]
    },
    {
      "id": "musk",
      "label": "Myskigt & rent",
      "desc": "Mjuk mysk och en ren känsla.",
      "image": "parfymtest-myskigt-rent.png?v=1789508511",
      "alt": "En omärkt glasflaska bland vit bomull, blomblad och böljande tyg.",
      "profiles": [
        "Myskig",
        "Musky",
        "Muskig"
      ],
      "notes": [
        "Mysk",
        "Vit mysk",
        "Musk",
        "White musk",
        "Ambrette",
        "Myskmalva"
      ]
    },
    {
      "id": "woody",
      "label": "Träigt",
      "desc": "Träkaraktär, värme och djup.",
      "image": "parfymtest-traigt.png?v=1789508528",
      "alt": "Träbitar och hyvelspån på en stenbricka i varmt brunt ljus.",
      "profiles": [
        "Träig"
      ],
      "notes": [
        "Cederträ",
        "Sandelträ",
        "Guajakträ",
        "Vetiver"
      ]
    },
    {
      "id": "spicy",
      "label": "Kryddigt",
      "desc": "Kardemumma, peppar och varm krydda.",
      "image": "parfymtest-kryddigt.png?v=1789508544",
      "alt": "Kardemumma, kanelstänger, svartpeppar och saffran på en stenbricka.",
      "profiles": [
        "Kryddig"
      ],
      "notes": [
        "Kanel",
        "Kardemumma",
        "Svartpeppar",
        "Rosépeppar",
        "Peppar",
        "Kryddnejlika",
        "Saffran",
        "Ingefära"
      ]
    },
    {
      "id": "amber",
      "label": "Amber / varmt & sensuellt",
      "desc": "Gyllene värme, kåda och mjukt djup.",
      "image": "parfymtest-amber-varmt-sensuellt.png?v=1789508555",
      "alt": "Gyllene kådbitar i en skål med vaniljstänger och trä i varmt ljus.",
      "profiles": [
        "Amber",
        "Amberig",
        "Ambrig",
        "Bärnstensaktig",
        "Hartsig",
        "Balsamisk"
      ],
      "notes": [
        "Amber",
        "Bensoin",
        "Benzoin",
        "Labdanum"
      ]
    },
    {
      "id": "oud",
      "label": "Oud & mörkt",
      "desc": "Djup oud och fyllig karaktär.",
      "image": "parfymtest-oud-morkt.png?v=1789508642",
      "alt": "Mörka träbitar och kåda framför ett rykande rökelsekärl.",
      "profiles": [
        "Oud",
        "Oudig"
      ],
      "notes": [
        "Oud",
        "Agarträ"
      ]
    },
    {
      "id": "leather",
      "label": "Läder & rökigt",
      "desc": "Läder, mocka eller en rökig känsla.",
      "image": "parfymtest-lader-rokigt.png?v=1789508683",
      "alt": "Brunt läder och mocka intill förkolnade träbitar och rökslingor.",
      "profiles": [
        "Läderaktig",
        "Läderig",
        "Läder",
        "Rökig",
        "Smoky"
      ],
      "notes": [
        "Läder",
        "Mocka",
        "Rök",
        "Rökelse",
        "Björktjära",
        "Birktjära"
      ]
    },
    {
      "id": "tropical",
      "label": "Tropiskt & exotiskt",
      "desc": "Kokos, ananas och semesterkänsla.",
      "image": "parfymtest-tropiskt-exotiskt.png?v=1789508656",
      "alt": "Kokos, ananas, mango och passionsfrukt med tropiska blommor och blad.",
      "profiles": [
        "Tropisk",
        "Kokosig",
        "Ananasfruktig",
        "Mangofruktig"
      ],
      "notes": [
        "Kokos",
        "Kokosmjölk",
        "Kokosvatten",
        "Ananas",
        "Mango",
        "Passionsfrukt",
        "Papaya",
        "Guava"
      ]
    },
    {
      "id": "boozy",
      "label": "Boozy / likörigt",
      "desc": "Rom, konjak och liköriga dofttoner.",
      "image": "parfymtest-boozy-likorigt.png?v=1789508710",
      "alt": "Ett konjaksglas och mörka körsbär framför ett träfat i varmt ljus.",
      "profiles": [
        "Boozy",
        "Likörig",
        "Spritig",
        "Romaktig",
        "Konjaksaktig"
      ],
      "notes": [
        "Rom",
        "Cognac",
        "Konjak",
        "Whisky",
        "Whiskey",
        "Likör",
        "Brandy"
      ]
    }
  ];
  const AVOIDS = [
    { id: 'oud', label: 'Oud', profiles: ['Oud', 'Oudig'], notes: ['Oud', 'Agarträ'] },
    { id: 'smoke', label: 'Rökighet', profiles: ['Rökig', 'Smoky'], notes: ['Rök', 'Rökelse', 'Birktjära', 'Björktjära'] },
    { id: 'leather', label: 'Läder', profiles: ['Läderaktig', 'Läderig', 'Läder'], notes: ['Läder', 'Mocka'] },
    { id: 'tobacco', label: 'Tobak', profiles: ['Tobaksrik', 'Tobak'], notes: ['Tobak', 'Tobaksblad', 'Tobaksblomma'] },
    { id: 'sweet', label: 'Tydlig sötma', profiles: ['Söt', 'Sockersöt', 'Godislik', 'Gourmand', 'Karamellig', 'Honungig'], notes: [] },
    { id: 'floral', label: 'Blommighet', profiles: ['Blommig', 'Rosig'], notes: ['Ros', 'Jasmin', 'Tuberos', 'Apelsinblomma', 'Pion'] },
    { id: 'powder', label: 'Pudrighet', profiles: ['Pudrig', 'Powdery'], notes: [] },
    { id: 'boozy', label: 'Spritig doft', profiles: ['Boozy', 'Likörig', 'Spritig', 'Romaktig', 'Konjaksaktig'], notes: ['Rom', 'Cognac', 'Konjak', 'Whisky', 'Whiskey', 'Likör', 'Brandy'] }
  ];

  function norm(value) {
    return String(value == null ? '' : value).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[’‘`]/g, "'").replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function values(value) {
    if (value == null) return [];
    if (Array.isArray(value)) return value.flatMap(values);
    if (typeof value === 'number') return Number.isFinite(value) ? [String(value)] : [];
    if (typeof value !== 'string') return [];
    const text = value.trim();
    if (!text) return [];
    if (text.startsWith('[')) {
      try { const parsed = JSON.parse(text); if (Array.isArray(parsed)) return values(parsed); } catch (_) { /* Bevara texten. */ }
    }
    // Dela INTE på | eller komma: de kan ingå i ett registrerat doftnamn.
    return text.split(/\r?\n/).map(v => v.trim()).filter(Boolean);
  }
  function unique(list) {
    const seen = new Set();
    return list.filter(v => { const key = norm(v); if (!key || seen.has(key)) return false; seen.add(key); return true; });
  }
  function verified(value) {
    return values(value).filter(v => !/\b(ej sakert verifierat|ej verifierat|inte verifierat)\b/.test(norm(v)) && !/^(okand|unknown|ingen|inget|none|n a|original|egen doft|ej tillampligt)$/.test(norm(v)));
  }
  function numberValue(value) {
    const v = values(value)[0];
    if (!v || !/^\s*\d+(?:[.,]\d+)?\s*\+?\s*$/.test(v)) return null;
    const n = Number.parseFloat(v.replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  }
  function hoursValue(meta) {
    const stored = numberValue(meta.hours);
    if (stored !== null && stored > 0 && stored <= 48) return stored;
    // En angiven intervalls lägre gräns används. Saknat värde är inte noll timmar.
    const text = values(meta.longevity).join(' ');
    const match = text.match(/^\s*(\d+(?:[.,]\d+)?)\s*(?:[+]|[-–—]\s*\d+(?:[.,]\d+)?)?\s*(?:timmar|tim|h|hours?)?\s*$/i);
    const n = match ? Number.parseFloat(match[1].replace(',', '.')) : null;
    return n !== null && n > 0 && n <= 48 ? n : null;
  }
  function audiences(raw) {
    // ParfymDupe underhåller Herr / Dam / Unisex som produkttags.
    // Om någon av dessa exakta könstags finns är tags den definitiva källan.
    // Äldre metafält, automatiska kollektioner och produkttyp får då inte
    // lägga till ett motstridigt kön. De används bara som reserv när könstag saknas.
    const tags = values(raw.tags).map(norm);
    const hasFemaleTag = tags.includes('dam');
    const hasMaleTag = tags.includes('herr');
    const hasUnisexTag = tags.includes('unisex');

    if (hasUnisexTag) return new Set(['unisex']);
    if (hasFemaleTag || hasMaleTag) {
      const tagged = new Set();
      if (hasFemaleTag) tagged.add('female');
      if (hasMaleTag) tagged.add('male');
      return tagged;
    }

    // Reserv för produkter som ännu saknar Herr / Dam / Unisex-tag.
    // raw.audiences kommer från produktens relevanta kollektioner i dataflödet.
    const fallback = [].concat(values(raw.meta && raw.meta.gender), values(raw.audiences), values(raw.type));
    const result = new Set();
    fallback.forEach(value => {
      const v = norm(value);
      if (/^(dam|damparfym|kvinna|kvinnor|women|woman|female|for henne|feminine)$/.test(v)) result.add('female');
      if (/^(herr|herrparfym|man|manlig|men|male|for honom|masculine)$/.test(v)) result.add('male');
      if (/^(unisex|gender neutral|konneutral)$/.test(v)) result.add('unisex');
    });
    return result;
  }
  function prepareProduct(raw, index) {
    if (Array.isArray(raw.variants) && raw.variants.length) {
      const bottles = raw.variants.filter(v => !isSampleVariant(v.title));
      const available = bottles.filter(v => v.available === true).sort((a, b) => a.price - b.price);
      const chosen = available[0] || bottles[0];
      if (chosen) raw = { ...raw, available: available.length > 0, price: chosen.price, price_text: chosen.price_text,
        compare: chosen.compare || 0, compare_text: chosen.compare_text || '', variant_title: chosen.title,
        url: String(raw.url || '').split('?')[0] + '?variant=' + chosen.id };
    }
    const meta = raw.meta && typeof raw.meta === 'object' ? raw.meta : {};
    const profiles = unique(values(meta.profiles).concat(values(meta.profile_detail)));
    const notes = unique(['notes', 'top', 'heart', 'base'].flatMap(k => values(meta[k])));
    const originalBrands = verified(meta.inspired_brand);
    const originalFragrances = verified(meta.inspired_fragrance);
    const descriptors = norm([raw.title, raw.type].join(' '));
    const tags = values(raw.tags).map(norm);
    const excluded = /\b(sample|samples|samplepaket|discovery set|provpaket|doftprov|atomizer|atomiser|refillbar|presentkort|gift card|tomflaska|tom flaska|deodorant|body lotion|duschgel)\b/.test(descriptors) ||
      /\b3\s*ml\b/.test(descriptors) || (Array.isArray(raw.variants) && raw.variants.length > 0 && raw.variants.every(v => isSampleVariant(v.title))) || tags.some(t => ['pd quiz exclude', 'quiz exclude', 'sample', 'samples', 'samplepaket', 'tillbehor'].includes(t));
    const evidence = profiles.length || notes.length || originalFragrances.length;
    const projection = numberValue(meta.projection);
    return {
      ...raw, meta, index, profiles, notes, originalBrands, originalFragrances,
      profileSet: new Set(profiles.map(norm)), noteSet: new Set(notes.map(norm)),
      seasons: unique(values(meta.seasons)), occasions: unique(values(meta.occasions)),
      audience: audiences(raw), hours: hoursValue(meta),
      projection: projection !== null && projection >= 1 && projection <= 5 ? projection : null,
      eligible: !excluded && !!evidence && Number.isFinite(raw.price) && raw.price >= 0,
      searchText: norm([raw.title, raw.vendor, ...originalBrands, ...originalFragrances].join(' '))
    };
  }
  function matches(set, labels) { return labels.filter(v => set.has(norm(v))); }
  function groupEvidence(product, group, noteFallback = true) {
    const profile = matches(product.profileSet, group.profiles);
    if (profile.length) return { strength: 1, label: profile[0], field: 'profile' };
    // En tränot innebär INTE att doften är trädominerad. Träig måste finnas i profilen.
    if (group.id === 'woody') return { strength: 0, label: '', field: '' };
    const note = noteFallback ? matches(product.noteSet, group.notes) : [];
    return note.length ? { strength: 0.55, label: note[0], field: 'note' } : { strength: 0, label: '', field: '' };
  }
  function canAudience(product, value) {
    if (!value || value === 'any') return true;
    if (value === 'unisex') return product.audience.has('unisex') || (product.audience.has('female') && product.audience.has('male'));
    return product.audience.has(value) || product.audience.has('unisex');
  }
  function scoreProduct(product, answers, options = {}) {
    // Lagerstatus avgränsar urvalet, men påverkar aldrig doftpoängen.
    // Bara ett uttryckligt true tar med produkter med känd slutsåld-status.
    const allowedStock = product.available === true || (options?.includeSoldout === true && product.available === false);
    if (!product.eligible || !allowedStock || !canAudience(product, answers.audience)) return null;
    if (Number(answers.budget) > 0 && product.price > Number(answers.budget)) return null;
    const avoid = answers.avoid || [];
    if (avoid.length && !product.profiles.length && !product.notes.length) return null;
    if (avoid.some(id => {
      const rule = AVOIDS.find(g => g.id === id);
      return rule && (matches(product.profileSet, rule.profiles).length || matches(product.noteSet, rule.notes).length);
    })) return null;

    let points = 0, possible = 0, known = 0, dimensions = 0, knownDimensions = 0;
    const breakdown = [];
    const reasons = [], unknown = [];
    const add = (weight, fraction, hasData, reason, missing) => {
      possible += weight; dimensions++;
      if (hasData) knownDimensions++;
      breakdown.push({ label: missing, weight, earned: weight * Math.max(0, Math.min(1, fraction)), known: !!hasData });
      if (hasData) known += weight;
      else if (missing) unknown.push(missing);
      points += weight * Math.max(0, Math.min(1, fraction));
      if (reason && fraction > 0) reasons.push(reason);
    };
    const selectedFamilies = (answers.family || []).map(id => GROUPS.find(g => g.id === id)).filter(Boolean);
    let primaryMatch = true;
    if (selectedFamilies.length) {
      const hits = selectedFamilies.map(g => ({ group: g, ...groupEvidence(product, g) }));
      primaryMatch = hits.some(h => h.strength > 0);
      const fraction = hits.reduce((n, h) => n + h.strength, 0) / selectedFamilies.length;
      add(36, fraction, !!(product.profiles.length || product.notes.length), '', 'Doftprofil');
      hits.filter(h => h.strength).forEach(h => reasons.push(h.field === 'profile' ? 'Doftprofil: ' + h.label : 'Registrerad not: ' + h.label));
    }
    const wantedNotes = answers.notes || [];
    if (wantedNotes.length) {
      const hits = wantedNotes.filter(n => product.noteSet.has(norm(n)));
      add(22, hits.length / wantedNotes.length, !!product.notes.length, hits.length ? 'Noter du gillar: ' + hits.slice(0, 3).join(', ') : '', 'Noter');
    }
    if (answers.sweetness && answers.sweetness !== 'any') {
      const high = matches(product.profileSet, ['Sockersöt', 'Godislik', 'Gourmand', 'Söt']).length > 0;
      const middle = matches(product.profileSet, ['Vaniljig', 'Krämig', 'Mjuk']).length > 0;
      const dry = matches(product.profileSet, ['Torr', 'Torrträig', 'Osöt', 'Ej söt']).length > 0;
      let fraction = 0, reason = '';
      if (answers.sweetness === 'high' && high) { fraction = 1; reason = 'Söt doftprofil'; }
      if (answers.sweetness === 'medium' && middle) { fraction = high ? 0.45 : 0.8; reason = 'Mjuk eller vaniljig profil'; }
      if (answers.sweetness === 'low' && dry) { fraction = 1; reason = 'Torr doftprofil'; }
      if (answers.sweetness === 'low' && !high && matches(product.profileSet, ['Fräsch', 'Grön', 'Citrusig', 'Aromatisk']).length) {
        fraction = 0.45; reason = 'Fräsch eller aromatisk profil';
      }
      // Avsaknad av taggen Söt blir aldrig bevis för en osöt parfym.
      add(10, fraction, !!product.profiles.length, reason, 'Sötma i doftprofil');
    }
    const wantedSeasons = answers.seasons || [];
    if (wantedSeasons.length) {
      const set = new Set(product.seasons.map(norm));
      const hit = wantedSeasons.filter(v => set.has(norm(v)));
      add(10, hit.length / wantedSeasons.length, !!product.seasons.length, hit.length ? 'Passar under: ' + hit.join(', ') : '', 'Årstid');
    }
    const wantedOccasions = answers.occasions || [];
    if (wantedOccasions.length) {
      const set = new Set(product.occasions.map(norm));
      const hit = wantedOccasions.filter(v => set.has(norm(v)));
      add(10, hit.length / wantedOccasions.length, !!product.occasions.length, hit.length ? 'Passar för: ' + hit.join(', ') : '', 'Tillfälle');
    }
    if (answers.projection && answers.projection !== 'any') {
      const p = product.projection;
      const ok = p !== null && (answers.projection === 'close' ? p <= 2 : answers.projection === 'balanced' ? p === 3 : p >= 4);
      add(10, ok ? 1 : 0, p !== null, ok ? 'Doftspridning enligt ditt val' : '', 'Doftspridning');
    }
    if (Number(answers.longevity) > 0) {
      const target = Number(answers.longevity);
      const fraction = product.hours === null ? 0 : Math.min(1, product.hours / target);
      const ok = product.hours !== null && product.hours >= target;
      // Kortare hållbarhet kan få delpoäng, men aldrig en påhittad förklaring.
      add(10, ok ? 1 : fraction * 0.35, product.hours !== null, ok ? 'Registrerad hållbarhet passar ditt önskemål' : '', 'Hållbarhet');
    }
    if (possible && points <= 0) return null;
    const ratio = possible ? points / possible : 0;
    const coverage = possible ? known / possible : 1;
    return { product, score: ratio, coverage, possible, dimensions, knownDimensions, breakdown,
      percentage: dimensions >= 3 && knownDimensions >= 3 && coverage >= 0.6 ? Math.min(100, Math.max(0, Math.floor(ratio * 100 + 0.5))) : null,
      reasons: unique(reasons).slice(0, 4), unknown: unique(unknown),
      label: !possible ? 'Förslag att utforska' : ratio >= 0.65 && coverage >= 0.65 && primaryMatch ? 'Stark profilmatch' : 'Delvis profilmatch' };
  }
  function rankProducts(products, answers, options = {}) {
    return products.map(p => scoreProduct(p, answers, options)).filter(Boolean)
      .sort((a, b) => b.score - a.score || b.coverage - a.coverage ||
        Number(b.product.available) - Number(a.product.available) || a.product.index - b.product.index);
  }

  function isSampleVariant(title) {
    return /\b(?:3\s*ml|sample|samples|doftprov)\b/.test(norm(title));
  }
  function perfumeIdentity(product) {
    let name = ' ' + norm(product.title) + ' ';
    const vendor = norm(product.vendor);
    if (vendor) name = name.split(' ' + vendor + ' ').join(' ');
    const concentration = /\bextrait\b/.test(name) ? 'extrait' : /\b(edt|eau de toilette)\b/.test(name) ? 'edt' : /\b(edp|eau de parfum)\b/.test(name) ? 'edp' : '';
    name = name.replace(/\b(?:eau de parfum|eau de toilette|extrait de parfum|edp|edt)\b/g, ' ')
      .replace(/\b(?:sample|samples|doftprov)\b/g, ' ').replace(/\b\d+(?:[.,]\d+)?\s*ml\b/g, ' ');
    // Intense, Elixir, Parfum, Extrait (when part of the name), etc. are NOT discarded.
    return { name: norm(name), vendor, concentration };
  }
  function uniqueRecommendations(products, answers, options = {}) {
    const seen = new Set();
    return rankProducts(products, answers, options).filter(item => {
      const identity = perfumeIdentity(item.product);
      const key = identity.vendor ? [identity.vendor, identity.name, identity.concentration].join('|') : item.product.id;
      if (seen.has(key)) return false;
      seen.add(key); return true;
    });
  }
  function topRecommendations(products, answers, options = {}) {
    // Behåll det tidigare topp-tre-kontraktet för befintliga kontroller och tomma resultat.
    return uniqueRecommendations(products, answers, options).slice(0, QUIZ_BATCH_SIZE);
  }
  function isRelevantExtra(item, answers) {
    if (!item.possible || item.score < EXTRA_MIN_SCORE || item.coverage < EXTRA_MIN_COVERAGE) return false;
    const families = (answers.family || []).map(id => GROUPS.find(group => group.id === id)).filter(Boolean);
    // Ett extra kort måste ha stöd för minst en vald doftriktning, om sådan har valts.
    return !families.length || families.some(group => groupEvidence(item.product, group).strength > 0);
  }
  function quizRecommendations(products, answers, options = {}) {
    const ranked = uniqueRecommendations(products, answers, options);
    const first = ranked.slice(0, QUIZ_BATCH_SIZE);
    const extra = ranked.slice(QUIZ_BATCH_SIZE).filter(item => isRelevantExtra(item, answers));
    return first.concat(extra).slice(0, QUIZ_MAX_RESULTS);
  }
  function prepareSample(raw) {
    if (!raw || typeof raw.title !== 'string') return null;
    let sample = { ...raw };
    const text = norm([raw.title, raw.type, ...values(raw.tags)].join(' '));
    if (/\b(samplepaket|provpaket|discovery set|set of|atomizer|atomiser|tomflaska|refillbar)\b/.test(text)) return null;
    const productIs3ml = /\b3\s*ml\b/.test(text) && !/\b(?:\d+\s*(?:x|pack)|paket|set)\b/.test(text);
    if (Array.isArray(raw.variants) && raw.variants.length) {
      const options = raw.variants.filter(v => {
        const variantText = norm(v.title);
        if (/\b(?:\d+\s*(?:x|pack)|paket|set)\b/.test(variantText)) return false;
        return /\b3\s*ml\b/.test(variantText) || (productIs3ml && !/\b\d+(?:\s+\d+)?\s*ml\b/.test(variantText));
      });
      const chosen = options.find(v => v.available === true) || options[0];
      if (!chosen) return null;
      sample = { ...raw, price: chosen.price, price_text: chosen.price_text, available: chosen.available,
        variant_id: String(chosen.id), url: String(raw.url || '').split('?')[0] + '?variant=' + chosen.id, variant_title: chosen.title };
    } else if (!productIs3ml && !/\b3\s*ml\b/.test(norm(raw.variant_title))) return null;
    if (typeof sample.available !== 'boolean' || !Number.isFinite(sample.price) || sample.price < 0 || !sample.url) return null;
    return { ...sample, id: String(sample.id), identity: perfumeIdentity(raw) };
  }
  function makeSampleIndex(rows) {
    const index = { byParent: new Map(), byName: new Map() };
    rows.map(prepareSample).filter(Boolean).forEach(sample => {
      const add = (map, key) => { if (!map.has(key)) map.set(key, []); map.get(key).push(sample); };
      if (sample.parent_id) add(index.byParent, String(sample.parent_id));
      if (sample.identity.vendor && sample.identity.name) add(index.byName, sample.identity.vendor + '|' + sample.identity.name);
    });
    return index;
  }
  function linkedSample(product, index) {
    // An explicit shop-maintained product link wins, including its sold-out state.
    if (product.sample) return prepareSample(product.sample);
    const own = prepareSample(product);
    if (own) return own;
    if (!index) return null;
    const parents = index.byParent.get(String(product.id)) || [];
    if (parents.length) return parents.length === 1 ? parents[0] : null;
    const identity = perfumeIdentity(product);
    const candidates = (index.byName.get(identity.vendor + '|' + identity.name) || []).filter(sample =>
      !sample.parent_id && (!identity.concentration || !sample.identity.concentration || identity.concentration === sample.identity.concentration));
    // Never choose by fuzzy title, inspiration, price or stock when several candidates exist.
    return candidates.length === 1 ? candidates[0] : null;
  }
  function expandedQuery(query) {
    return norm(query).replace(/\bysl\b/g, 'yves saint laurent').replace(/\bpdm\b/g, 'parfums de marly')
      .replace(/\bjpg\b/g, 'jean paul gaultier').replace(/\bmfk\b/g, 'maison francis kurkdjian');
  }
  function searchProducts(products, query, brand, showSoldout) {
    const q = expandedQuery(query), tokens = q.split(' ').filter(Boolean), b = norm(brand);
    return products.filter(p => p.eligible && (showSoldout || p.available) && (!b || p.originalBrands.some(v => norm(v) === b)))
      .map(p => {
        if (!tokens.every(t => p.searchText.includes(t))) return null;
        const original = p.originalFragrances.map(norm);
        const score = !q ? 0 : original.includes(q) ? 100 : original.some(v => v.startsWith(q)) ? 75 : norm(p.title) === q ? 90 : norm(p.title).startsWith(q) ? 60 : 25;
        return { product: p, score, label: '', reasons: [], unknown: [] };
      }).filter(Boolean).sort((a, b) => Number(b.product.available) - Number(a.product.available) || b.score - a.score || a.product.index - b.product.index);
  }
  function allValues(products, field) {
    const counts = new Map();
    products.filter(p => p.eligible).forEach(p => unique(p[field] || []).forEach(v => {
      const key = norm(v), item = counts.get(key);
      if (item) item.count++;
      else counts.set(key, { label: v, count: 1 });
    }));
    return Array.from(counts.values()).sort((a, b) => b.count - a.count || a.label.localeCompare(b.label, 'sv'));
  }
  function makeQuestions(products, cfg, pending = false) {
    const eligible = products.filter(p => p.eligible);
    const profile = eligible.some(p => p.profiles.length);
    const list = [
      { id: 'family', title: 'Vilka dofter dras du till?', text: 'Följ magkänslan. Välj upp till två bilder som känns som du.', max: 2, options: GROUPS.map(g => ({ value: g.id, label: g.label, desc: g.desc, image: g.id })) }
    ];
    if (pending || eligible.some(p => p.audience.size)) list.push({ id: 'audience', title: 'Vilken avdelning vill du utforska?', text: 'Välj hur du brukar leta. Unisexdofter kan även visas när du väljer dam eller herr.', options: [
      { value: 'female', label: 'Dam', desc: 'Dam- och unisexparfymer.' }, { value: 'male', label: 'Herr', desc: 'Herr- och unisexparfymer.' },
      { value: 'unisex', label: 'Unisex', desc: 'Dofter för alla.' }, { value: 'any', label: 'Alla dofter', desc: 'Jag väljer efter doften.' }
    ] });
    if (pending || profile) list.push({ id: 'sweetness', title: 'Hur känner du för sötma?', text: 'Vi väger in butikens registrerade doftprofil. Sötma är en mjuk preferens, inte ett exakt mätvärde.', options: [
      { value: 'low', label: 'Helst inte sött', desc: 'Jag dras mer till fräscht, grönt eller torrt.' },
      { value: 'medium', label: 'Lite mjuk sötma', desc: 'Gärna en mjuk eller vaniljig känsla.' },
      { value: 'high', label: 'Jag gillar sött', desc: 'Söta, godislika eller gourmandiga dofter.' }
    ] });
    const occasions = allValues(eligible, 'occasions');
    if (pending || occasions.length) list.push({ id: 'occasions', loading: pending, title: 'När vill du använda parfymen?', text: 'Tänk på när du helst vill bära din nya doft. Välj upp till två.', max: 2, options: occasions.slice(0, 12).map(v => ({ value: v.label, label: v.label })) });
    const seasons = allValues(eligible, 'seasons');
    if (pending || seasons.length) list.push({ id: 'seasons', loading: pending, title: 'Vilken årstid ska den passa?', text: 'Välj upp till två. Hoppa över frågan om årstiden inte spelar någon roll.', max: 2,
      options: seasons.sort((a, b) => ['var', 'sommar', 'host', 'vinter'].indexOf(norm(a.label)) - ['var', 'sommar', 'host', 'vinter'].indexOf(norm(b.label))).map(v => ({ value: v.label, label: v.label })) });
    if (pending || eligible.some(p => p.projection !== null)) list.push({ id: 'projection', title: 'Hur mycket ska doften märkas?', text: 'Doftspridning handlar om hur långt doften upplevs, inte hur många timmar den sitter kvar.', options: [
      { value: 'close', label: 'Nära huden', desc: 'Diskret – nivå 1–2 i butikens skala.' },
      { value: 'balanced', label: 'Lagom tydlig', desc: 'Märks omkring dig – nivå 3.' },
      { value: 'strong', label: 'Tydlig närvaro', desc: 'Jag vill att doften ska märkas.' }
    ] });
    if (pending || eligible.some(p => p.hours !== null)) list.push({ id: 'longevity', title: 'Hur länge vill du att den ska hålla?', text: 'Vi jämför med registrerad hållbarhet. Tiden på din hud kan variera.', options: [
      { value: '6', label: 'Omkring 6 timmar eller mer', desc: 'För en del av dagen.' },
      { value: '8', label: 'Omkring 8 timmar eller mer', desc: 'För en längre dag.' },
      { value: '10', label: 'Omkring 10 timmar eller mer', desc: 'Jag prioriterar lång hållbarhet.' }
    ] });
    const notes = allValues(eligible, 'notes');
    if (pending || notes.length) list.push({ id: 'notes', loading: pending, title: 'Finns det några noter du gillar extra?', text: 'Valfritt: välj upp till tre. Sök bland de noter som faktiskt finns registrerade i sortimentet.', max: 3, searchable: true, options: notes.map(v => ({ value: v.label, label: v.label })) });
    if (pending || profile || notes.length) list.push({ id: 'avoid', title: 'Är det något du helst vill undvika?', text: 'Välj upp till tre. Vi sorterar bort registrerade träffar, men saknade noter kan inte uteslutas. Detta är inget allergifilter.', max: 3,
      options: AVOIDS.map(v => ({ value: v.id, label: v.label })) });
    const money = amount => new Intl.NumberFormat(cfg.locale || 'sv-SE', { style: 'currency', currency: cfg.currency || 'SEK', maximumFractionDigits: 0 }).format(amount);
    list.push({ id: 'budget', title: 'Vad får den stora flaskan kosta?', text: 'Vi håller oss inom din gräns för den stora flaskan. På resultatet kan du börja med ett 3 ml-prov där det finns.', options: unique((cfg.budgets || [300, 500, 700]).map(String)).map(v => ({ value: String(Number(v) * 100), label: 'Upp till ' + money(Number(v)) }))
      .concat([{ value: '0', label: 'Ingen bestämd gräns', desc: 'Visa alla prisklasser.' }]) });
    // The long test keeps the natural order above; the quick test has four questions.
    return list.sort((a, b) => QUESTION_ORDER.indexOf(a.id) - QUESTION_ORDER.indexOf(b.id))
      .map(q => ({ ...q, optional: !QUICK_QUESTIONS.includes(q.id) }));
  }
  // Samma frågor och poäng. Fasta svarsalternativ kommer först medan katalogen hämtas.
  const QUICK_QUESTIONS = ['family', 'audience', 'projection', 'occasions'];
  const QUESTION_ORDER = ['family', 'audience', 'sweetness', 'projection', 'longevity', 'budget', 'occasions', 'seasons', 'notes', 'avoid'];
  function questionsFor(questions, mode = 'quick', stage = 'core') {
    if (stage === 'refine') return questions.filter(q => q.optional);
    return mode === 'long' ? questions.slice() : questions.filter(q => !q.optional);
  }
  function sizedShopifyImage(value, width) {
    // Preserve the exact file/version. Only resize recognised Shopify image URLs.
    try {
      const url = new URL(value);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (url.hostname !== 'cdn.shopify.com' && !url.pathname.startsWith('/cdn/shop/')) return value;
      url.searchParams.set('width', String(Math.max(80, Math.min(1000, Math.round(width)))));
      return url.href;
    } catch (_) { return value; }
  }
  function diagnosticRows(products) {
    const valid = products.filter(p => p.eligible);
    return [
      ['Doftprofil', p => p.profiles.length], ['Noter', p => p.notes.length], ['Årstider', p => p.seasons.length],
      ['Tillfällen / Best for', p => p.occasions.length], ['Hållbarhet', p => p.hours !== null],
      ['Doftspridning', p => p.projection !== null], ['Dam / herr / unisex', p => p.audience.size],
      ['Verifierat originalnamn', p => p.originalFragrances.length]
    ].map(([label, fn]) => [label, valid.filter(fn).length, valid.length]);
  }
  const API = { norm, values, verified, prepareProduct, groupEvidence, scoreProduct, rankProducts, searchProducts, makeQuestions, diagnosticRows, topRecommendations, quizRecommendations, isRelevantExtra, QUIZ_BATCH_SIZE, QUIZ_MAX_RESULTS, perfumeIdentity, prepareSample, makeSampleIndex, linkedSample, GROUPS, AVOIDS, questionsFor, sizedShopifyImage, QUICK_QUESTIONS };
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  if (typeof document === 'undefined' || typeof customElements === 'undefined') return;
  if (customElements.get('pd-perfume-finder')) return;

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }
  function button(text, action, className = 'pdf-btn') {
    const node = el('button', className, text); node.type = 'button';
    if (action) node.addEventListener('click', action);
    return node;
  }
  function safeURL(value, image = false) {
    if (!value) return '';
    try {
      const url = new URL(String(value), window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      if (!image && url.origin !== window.location.origin) return '';
      return url.href;
    } catch (_) { return ''; }
  }
  function imageNode(url, alt, className = '') {
    const node = el('img', className);
    const src = safeURL(url, true);
    if (src) node.src = src;
    node.alt = alt || ''; node.loading = 'lazy'; node.decoding = 'async';
    node.width = 640; node.height = 640;
    node.addEventListener('error', () => { node.hidden = true; node.parentElement && node.parentElement.classList.add('pdf-image-missing'); });
    return node;
  }

  class PerfumeFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const node = this.querySelector('[data-pdf-config]');
      if (!node) return;
      try { this.cfg = JSON.parse(node.textContent); } catch (_) { return; }
      this.ready = true;
      this.controller = new AbortController();
      this.answers = {};
      this.products = null;
      this.dataPromise = null; this.samplePromise = null;
      this.hasStarted = false; this.wasResults = false; this.editing = false;
      this.allQuestions = makeQuestions([], this.cfg, true);
      this.dataError = ''; this.loadMessage = ''; this.loadTotal = 0; this.ignoredAnswers = [];
      this.finishPromise = null; this.warmupStarted = false;
      this.quizMode = 'quick'; this.quizStage = 'core'; this.quizDrafts = Object.create(null);
      this.quizShowSoldout = false; // Separat från söklägets showSoldout. Inget sparas mellan sidladdningar.
      this.quizShown = QUIZ_BATCH_SIZE; this.quizResultsKey = ''; 
      this.questions = questionsFor(this.allQuestions, this.quizMode, this.quizStage);
      this.sampleState = 'idle';
      this.sampleRows = [];
      this.sampleIndex = makeSampleIndex([]);
      this.step = 0;
      this.view = 'home';
      this.loadedCount = 0;
      this.runId = (this.runId || 0) + 1;
      this.actionVersion = 0;
      this.advancing = false;
      this.queryTimer = 0;
      this.resultLimit = Math.max(3, Math.min(12, Number(this.cfg.results_per_page) || 6));
      this.main = this.querySelector('[data-pdf-main]');
      this.main?.replaceChildren();
      this.live = this.querySelector('[data-pdf-live]');
      this.status = this.querySelector('[data-pdf-status]');
      this.setupMobileActionDock();
      this.querySelectorAll('[data-pdf-start]').forEach(b => { b.addEventListener('click', () => this.startQuiz(b.dataset.pdfMode || 'quick'), { signal: this.controller.signal }); });
      this.updateStartButtons();
      this.querySelectorAll('[data-pdf-search]').forEach(b => b.addEventListener('click', () => this.startSearch(), { signal: this.controller.signal }));
      const diagnostic = this.querySelector('[data-pdf-diagnostics]');
      if (diagnostic) diagnostic.addEventListener('click', () => this.diagnostics(), { signal: this.controller.signal });
      this.querySelectorAll('[data-pdf-js]').forEach(b => { b.hidden = false; });
      this.querySelector('[data-pdf-nojs]')?.setAttribute('hidden', '');
      this.setStatus('');
      // Enbart offentlig katalogdata. Inga testsvar eller produkter lagras på disk.
      const warm = () => this.warmCatalogue();
      this.querySelectorAll('[data-pdf-start], [data-pdf-search]').forEach(b => {
        ['pointerenter', 'focus', 'touchstart'].forEach(type => b.addEventListener(type, warm,
          { once: true, passive: true, signal: this.controller.signal }));
      });
      const connection = navigator.connection;
      if (!connection?.saveData && !/^(slow-2g|2g)$/.test(connection?.effectiveType || '')) {
        this.warmupTimer = setTimeout(() => {
          if (!this.isConnected || document.visibilityState === 'hidden') return;
          if (window.requestIdleCallback) this.warmupIdle = window.requestIdleCallback(warm, { timeout: 1500 });
          else warm();
        }, 500);
      }
    }

    // V3.6: reserve space ABOVE the floating rewards launcher, instead of
    // racing its z-index. No app settings, network requests or click handlers
    // are changed. This only runs while mobile quiz questions are rendered.
    setupMobileActionDock() {
      this.mobileDockMedia = window.matchMedia('(max-width: 599px)');
      this.mobileDockSync = () => this.syncMobileActionDock();
      this.mobileDockMedia.addEventListener('change', this.mobileDockSync, { signal: this.controller.signal });
      this.mobileDockObserver = new MutationObserver(this.mobileDockSync);
      if (this.main) this.mobileDockObserver.observe(this.main, { childList: true });
      this.syncMobileActionDock();
    }
    syncMobileActionDock() {
      const actions = this.main?.querySelector('.pdf-quiz > .pdf-quiz-actions');
      if (!this.isConnected || !this.mobileDockMedia?.matches || !actions) {
        this.releaseMobileActionDock();
        return;
      }
      this.mobileDockActions = actions;
      this.classList.add('pdf-mobile-action-dock');
      if (!this.mobileDockEvents) {
        this.mobileDockEvents = new AbortController();
        this.mobileDockObserved = new Set();
        const schedule = () => this.scheduleMobileDockMeasure();
        const options = { passive: true, signal: this.mobileDockEvents.signal };
        window.addEventListener('resize', schedule, options);
        window.addEventListener('scroll', schedule, options);
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', schedule, options);
          window.visualViewport.addEventListener('scroll', schedule, options);
        }
        this.mobileDockResize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
        this.mobileDockStyleObserver = new MutationObserver(schedule);
        // Rewards can load after the quiz. Ignore changes inside our own quiz.
        this.mobileDockAppObserver = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) schedule();
        });
        if (document.body) this.mobileDockAppObserver.observe(document.body, { childList: true, subtree: true });
      }
      this.scheduleMobileDockMeasure();
    }
    scheduleMobileDockMeasure() {
      if (!this.mobileDockEvents || this.mobileDockFrame) return;
      this.mobileDockFrame = requestAnimationFrame(() => {
        this.mobileDockFrame = 0;
        this.measureMobileDock();
      });
    }
    measureMobileDock() {
      if (!this.mobileDockEvents || !this.mobileDockActions?.isConnected || !this.mobileDockMedia.matches) return;
      const viewportHeight = window.innerHeight;
      const viewportWidth = document.documentElement.clientWidth;
      // Includes the Smile containers already used elsewhere in this theme.
      // Ignore large panels/dialogs; they must keep their own overlay behavior.
      const selector = [
        '.smile-launcher-frame-container', '[class*="smile-launcher"]',
        '#smile-launcher', '#smile-ui-container', '#smile-ui-lite-container',
        '#smile-ui-container iframe', '#smile-ui-lite-container iframe',
        'iframe[id*="smile"][id*="launcher"]', 'iframe[title="Belöningar"]',
        'button[aria-label="Belöningar"]', 'a[aria-label="Belöningar"]'
      ].join(',');
      const candidates = Array.from(document.querySelectorAll(selector)).filter(node => !this.contains(node));
      const observed = new Set([this.mobileDockActions, ...candidates]);
      if (this.mobileDockResize) {
        this.mobileDockObserved.forEach(node => { if (!observed.has(node)) this.mobileDockResize.unobserve(node); });
        observed.forEach(node => { if (!this.mobileDockObserved.has(node)) this.mobileDockResize.observe(node); });
      }
      // A launcher can change its bottom offset without changing its size.
      // Observe only the matched app elements, not styles throughout the store.
      if (observed.size !== this.mobileDockObserved.size || Array.from(observed).some(node => !this.mobileDockObserved.has(node))) {
        this.mobileDockStyleObserver?.disconnect();
        candidates.forEach(node => this.mobileDockStyleObserver?.observe(node, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] }));
      }
      this.mobileDockObserved = observed;
      let clearance = 0;
      candidates.forEach(node => {
        const rect = node.getBoundingClientRect();
        const style = getComputedStyle(node);
        if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0 ||
          rect.width < 24 || rect.height < 24 || rect.height > Math.min(260, viewportHeight * .45) ||
          rect.right <= 0 || rect.left >= viewportWidth || rect.top < viewportHeight * .4 ||
          rect.top >= viewportHeight || rect.bottom < viewportHeight * .65) return;
        let floating = false;
        for (let parent = node; parent && parent !== document.body; parent = parent.parentElement) {
          const position = getComputedStyle(parent).position;
          if (position === 'fixed' || position === 'sticky') { floating = true; break; }
        }
        if (floating) clearance = Math.max(clearance, Math.ceil(viewportHeight - rect.top + 12));
      });
      // 96 px fallback fits the supplied screenshot and also covers launchers
      // inside an inaccessible shadow root or one that has not loaded yet.
      // The measured outer frame is used when available, including any padding.
      const value = (clearance || 96) + 'px';
      if (this.style.getPropertyValue('--pdf-rewards-clearance') !== value) this.style.setProperty('--pdf-rewards-clearance', value);
    }
    releaseMobileActionDock() {
      this.mobileDockEvents?.abort(); this.mobileDockEvents = null;
      this.mobileDockAppObserver?.disconnect(); this.mobileDockAppObserver = null;
      this.mobileDockResize?.disconnect(); this.mobileDockResize = null;
      this.mobileDockStyleObserver?.disconnect(); this.mobileDockStyleObserver = null;
      if (this.mobileDockFrame) cancelAnimationFrame(this.mobileDockFrame);
      this.mobileDockFrame = 0; this.mobileDockActions = null;
      this.mobileDockObserved = null;
      this.classList.remove('pdf-mobile-action-dock');
      this.style.removeProperty('--pdf-rewards-clearance');
    }

    warmCatalogue() {
      if (this.warmupStarted || !this.isConnected) return;
      this.warmupStarted = true;
      this.ensureData().catch(() => {}); // Synligt återförsök när kunden öppnar testet.
    }
    disconnectedCallback() {
      this.mobileDockObserver?.disconnect();
      this.releaseMobileActionDock();
      this.controller?.abort();
      this.fetchController?.abort();
      this.sampleController?.abort();
      clearTimeout(this.queryTimer); clearTimeout(this.warmupTimer);
      if (window.cancelIdleCallback && this.warmupIdle) window.cancelIdleCallback(this.warmupIdle);
      this.finishPromise = null; this.actionVersion++;
      this.runId++;
      this.ready = false;
    }
    announce(text) { if (this.live) this.live.textContent = text; }
    setStatus(text, error = false) {
      if (!this.status) return;
      this.status.replaceChildren();
      this.status.hidden = !text;
      if (!text) return;
      this.status.append(el('span', '', text));
      this.status.classList.toggle('pdf-status--error', error);
      if (error) this.status.append(button('Försök igen', () => {
        if (this.view === 'results-loading') { this.finishQuiz(true); return; }
        this.ensureData(true).then(() => {
          if (this.view === 'search') this.renderSearch();
          else if (this.view === 'results') this.renderResults();
          else if (this.view === 'quiz') this.renderQuestion(false);
        }).catch(() => {});
      }, 'pdf-link-button'));
    }
    scrollToMain() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.main.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    }
    focusTitle() {
      const title = this.main.querySelector('[data-pdf-title]');
      if (title) title.focus({ preventScroll: true });
    }
    heading(text) { const n = el('h2', 'pdf-title', text); n.tabIndex = -1; n.dataset.pdfTitle = ''; return n; }
    groupImage(id) {
      const custom = this.cfg.images && this.cfg.images[id];
      const item = GROUPS.find(g => g.id === id);
      return safeURL(custom || (item ? CDN + item.image : ''), true);
    }
    groupAlt(id) {
      const item = GROUPS.find(g => g.id === id);
      return this.cfg.images?.[id] ? (this.cfg.image_alts?.[id] || item?.label || '') : (item?.alt || '');
    }
    categoryImage(id, index) {
      const source = this.groupImage(id);
      const resized = sizedShopifyImage(source, 360);
      const image = imageNode(resized, this.groupAlt(id));
      image.width = 480; image.height = 480;
      if (resized && resized !== source) {
        image.srcset = [160, 240, 360, 480, 640].map(w => sizedShopifyImage(source, w) + ' ' + w + 'w').join(', ');
        image.sizes = '(min-width: 990px) 223px, (min-width: 600px) calc((100vw - 70px) / 4), calc((100vw - 42px) / 2)';
      }
      image.loading = index < 4 ? 'eager' : 'lazy';
      return image;
    }
    feedURL(page) {
      const url = new URL(this.cfg.collection_url, window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('Produktkällan måste finnas i samma butik.');
      url.search = '';
      url.searchParams.set('view', 'pd-finder-data');
      url.searchParams.set('page', String(page));
      // Behåll förhandsvisningstemat vid test i en opublicerad temakopia.
      const current = new URLSearchParams(window.location.search);
      ['preview_theme_id', '_fd', 'pb'].forEach(key => { if (current.has(key)) url.searchParams.set(key, current.get(key)); });
      return url;
    }
    async fetchPage(page, signal, force) {
      if (signal.aborted) throw new DOMException('Avbruten', 'AbortError');
      const url = this.feedURL(page);
      if (force) url.searchParams.set('_pd_refresh', String(this.refreshStamp));
      const timeout = new AbortController();
      const onAbort = () => timeout.abort();
      signal.addEventListener('abort', onAbort, { once: true });
      const timer = setTimeout(() => timeout.abort(), 22000);
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: timeout.signal, cache: force ? 'reload' : 'default' });
        if (!response.ok) throw new Error('Sortimentet kunde inte läsas (' + response.status + ').');
        const text = await response.text();
        let data;
        try { data = JSON.parse(text); }
        catch (_) { throw new Error('Produktkällan saknas eller ger fel format. Kontrollera collection.pd-finder-data.liquid.'); }
        if (!data || data.format !== VERSION || data.page !== page || data.page_size !== 250 || !Array.isArray(data.products) ||
          !Number.isInteger(data.total) || data.total < 0 || !Number.isInteger(data.pages) || data.pages < 0 || !data.collection_id) {
          throw new Error('Produktkällan gav ett oväntat svar. Kontrollera hjälpfilen.');
        }
        if (data.total > 25000) throw new Error('Välj en mindre parfymkollektion. Produktkällan stödjer upp till 25 000 produkter.');
        const pages = Math.max(1, Math.ceil(data.total / 250));
        if ((data.total > 0 && data.pages !== pages) || data.products.length !== Math.max(0, Math.min(250, data.total - (page - 1) * 250))) {
          throw new Error('Sortimentet ändrades under hämtningen. Försök igen.');
        }
        return data;
      } catch (error) {
        if (error.name === 'AbortError' && !signal.aborted) throw new Error('Hämtningen tog för lång tid. Försök igen.');
        throw error;
      } finally { clearTimeout(timer); signal.removeEventListener('abort', onAbort); }
    }
    updateLoadState(message = this.loadMessage, error = this.dataError) {
      this.loadMessage = message || '';
      this.dataError = error || '';
      const label = this.dataError || this.loadMessage || 'Förbereder produktuppgifterna…';
      this.main?.querySelectorAll('[data-pdf-load-text]').forEach(n => { n.textContent = label; });
      this.main?.querySelectorAll('[data-pdf-load-retry]').forEach(n => { n.hidden = !this.dataError; });
      this.main?.querySelectorAll('[data-pdf-load-track]').forEach(n => {
        if (this.loadTotal > 0) { n.max = this.loadTotal; n.value = this.loadedCount; }
        else n.removeAttribute('value');
        n.hidden = !!this.dataError;
      });
      // Inga globala laddningsmeddelanden under vanliga frågebyten.
      if (this.dataError && this.view !== 'home') this.setStatus(this.dataError, true);
      else this.setStatus('');
    }
    loadingPanel(forResult = false) {
      const panel = el('div', 'pdf-empty'); panel.dataset.pdfLoadingPanel = ''; panel.style.gridColumn = '1 / -1';
      panel.append(el('h3', '', forResult ? 'Vi jämför dina svar med sortimentet' : 'Förbereder alternativen'));
      const message = el('p'); message.dataset.pdfLoadText = ''; message.setAttribute('role', 'status');
      const progress = el('progress'); progress.dataset.pdfLoadTrack = '';
      progress.setAttribute('aria-label', 'Hämtade produktuppgifter');
      progress.style.cssText = 'display:block;width:100%;max-width:420px;height:10px;margin:16px auto;accent-color:var(--pdf-accent)';
      const retry = button('Försök igen', () => {
        if (forResult) this.finishQuiz(true);
        else this.ensureData(true).catch(() => {});
      }, 'pdf-btn pdf-btn--secondary'); retry.dataset.pdfLoadRetry = ''; retry.hidden = true;
      panel.append(message, progress, retry);
      if (forResult) panel.append(el('p', 'pdf-data-note', 'Alla produkter behöver läsas innan vi kan visa de bästa matchningarna. Dina svar finns kvar.'));
      else panel.append(el('p', 'pdf-data-note', 'Du kan gå tillbaka eller hoppa över frågan. Vi hittar inte på alternativ som saknas i produktdatan.'));
      return panel;
    }
    async prepareCatalogue(raw, signal, currentRun) {
      // Låt webbläsaren hantera klick mellan arbetsblock på långsammare mobiler.
      const prepared = new Array(raw.length);
      for (let start = 0; start < raw.length; start += 64) {
        if (signal.aborted || currentRun !== this.runId) throw new DOMException('Avbruten', 'AbortError');
        for (let i = start; i < Math.min(start + 64, raw.length); i++) prepared[i] = prepareProduct(raw[i], i);
        if (start + 64 < raw.length) await new Promise(resolve => setTimeout(resolve, 0));
      }
      return prepared;
    }
    async ensureData(force = false) {
      if (this.products && !force && Date.now() - this.loadedAt < TTL) return this.products;
      if (this.dataPromise && !force) return this.dataPromise;
      const key = this.feedURL(1).href + '|' + this.cfg.locale + '|' + this.cfg.currency + '|' + this.cfg.country;
      const saved = cache.get(key);
      if (!force && saved && Date.now() - saved.at < TTL) { this.useData(saved.data); return this.products; }
      this.fetchController?.abort();
      this.fetchController = new AbortController();
      const signal = this.fetchController.signal;
      this.refreshStamp = Date.now();
      const currentRun = ++this.runId;
      this.loadedCount = 0; this.loadTotal = 0;
      this.updateLoadState('Läser produktuppgifterna…', '');
      this.dataPromise = (async () => {
        try {
          const first = await this.fetchPage(1, signal, force);
          if (signal.aborted || currentRun !== this.runId) throw new DOMException('Avbruten', 'AbortError');
          if (first.currency !== this.cfg.currency) throw new Error('Valutan ändrades. Ladda om sidan för rätt priser.');
          const pages = Math.max(1, Math.ceil(first.total / 250));
          const chunks = new Array(pages); chunks[0] = first.products;
          this.loadTotal = first.total; this.loadedCount = first.products.length;
          this.updateLoadState('Läser produktuppgifter: ' + this.loadedCount + ' av ' + this.loadTotal + '.', '');
          let cursor = 2;
          const worker = async () => {
            while (cursor <= pages) {
              const page = cursor++;
              const data = await this.fetchPage(page, signal, force);
              if (data.collection_id !== first.collection_id || data.currency !== first.currency || data.total !== first.total || data.pages !== first.pages) {
                throw new Error('Sortimentet ändrades under hämtningen. Försök igen.');
              }
              if (signal.aborted || currentRun !== this.runId) throw new DOMException('Avbruten', 'AbortError');
              chunks[page - 1] = data.products; this.loadedCount += data.products.length;
              this.updateLoadState('Läser produktuppgifter: ' + this.loadedCount + ' av ' + this.loadTotal + '.', '');
            }
          };
          // Begränsad parallellism; inga obegränsade anrop eller fullständiga HTML-sidor.
          await Promise.all(Array.from({ length: Math.min(3, pages - 1) }, worker));
          if (signal.aborted || currentRun !== this.runId) throw new DOMException('Avbruten', 'AbortError');
          const raw = chunks.flat(), ids = new Set();
          raw.forEach(p => {
            if (!p || typeof p.id !== 'string' || !/^\d+$/.test(p.id) || ids.has(p.id) || typeof p.available !== 'boolean' || typeof p.title !== 'string') {
              throw new Error('Produktlistan är inte komplett. Försök igen.');
            }
            ids.add(p.id);
          });
          if (raw.length !== first.total) throw new Error('Produktlistan är inte komplett. Försök igen.');
          this.updateLoadState('Förbereder jämförelsen…', '');
          const prepared = await this.prepareCatalogue(raw, signal, currentRun);
          if (signal.aborted || currentRun !== this.runId) throw new DOMException('Avbruten', 'AbortError');
          const data = { raw, prepared, fields: first.fields, currency: first.currency, at: Date.now() };
          cache.set(key, { at: data.at, data });
          if (cache.size > 6) cache.delete(cache.keys().next().value);
          this.useData(data);
          return this.products;
        } catch (error) {
          if (!signal.aborted && currentRun === this.runId) this.fetchController.abort();
          if (currentRun === this.runId && this.isConnected && error.name !== 'AbortError') {
            this.updateLoadState('', error.message || 'Sortimentet kunde inte läsas.');
          }
          throw error;
        } finally { if (currentRun === this.runId) this.dataPromise = null; }
      })();
      return this.dataPromise;
    }
    useData(data) {
      this.loadedAt = data.at || Date.now();
      this.products = data.prepared || data.raw.map(prepareProduct);
      this.fields = data.fields || {};
      this.cfg.currency = data.currency || this.cfg.currency;
      const previous = this.questions[this.step];
      const currentId = previous?.id;
      this.allQuestions = makeQuestions(this.products, this.cfg);
      const supported = new Set(this.allQuestions.map(q => q.id));
      // En preliminär fråga kan sakna stöd i hela katalogen. Var tydlig om den inte kan användas.
      Object.keys(this.answers).forEach(id => {
        if (!supported.has(id)) {
          if (this.answers[id] !== undefined && this.answers[id] !== 'any' && values(this.answers[id]).length) {
            if (!this.ignoredAnswers.includes(id)) this.ignoredAnswers.push(id);
          }
          delete this.answers[id];
        }
      });
      Object.values(this.quizDrafts).forEach(draft => {
        Object.keys(draft.answers || {}).forEach(id => { if (!supported.has(id)) delete draft.answers[id]; });
      });
      this.questions = questionsFor(this.allQuestions, this.quizMode, this.quizStage);
      let index = this.questions.findIndex(q => q.id === currentId);
      if (index < 0) {
        index = this.questions.findIndex(q => QUESTION_ORDER.indexOf(q.id) > QUESTION_ORDER.indexOf(currentId));
        if (index < 0) index = Math.max(0, this.questions.length - 1);
      }
      this.step = index;
      this.updateLoadState('', '');
      this.querySelector('[data-pdf-total]')?.replaceChildren(document.createTextNode(String(this.products.filter(p => p.eligible).length)));
      // Byt aldrig ett synligt bildkort under pekaren. Bara tomma laddningspaneler fylls automatiskt.
      if (this.view === 'quiz' && (previous?.loading || this.questions[this.step]?.id !== currentId)) this.renderQuestion(false);
      else {
        this.updateProgress();
        const next = this.main?.querySelector('[data-pdf-next]');
        if (next) next.textContent = this.editing ? 'Uppdatera mina förslag' : this.step >= this.questions.length - 1 ? 'Visa mina bästa förslag' : 'Fortsätt';
      }
    }
    updateStartButtons() {
      this.querySelectorAll('[data-pdf-start]').forEach(b => {
        const mode = b.dataset.pdfMode === 'long' ? 'long' : 'quick';
        const started = mode === this.quizMode ? this.hasStarted : !!this.quizDrafts[mode];
        b.textContent = started ? (mode === 'long' ? 'Fortsätt långa testet' : 'Fortsätt snabbtestet') : (mode === 'long' ? 'Starta långt test' : 'Starta snabbt test');
      });
    }
    startQuiz(mode = this.quizMode, restart = false) {
      // Boolean argument retained for the existing "Börja om" button.
      if (typeof mode === 'boolean') { restart = mode; mode = this.quizMode; }
      mode = mode === 'long' ? 'long' : 'quick';
      const action = ++this.actionVersion;
      this.advancing = false; this.finishPromise = null;
      if (mode !== this.quizMode) {
        if (this.hasStarted) this.quizDrafts[this.quizMode] = {
          answers: JSON.parse(JSON.stringify(this.answers)), questionId: this.questions[this.step]?.id,
          stage: this.quizStage, editing: this.editing, wasResults: this.wasResults,
          includeSoldout: this.quizShowSoldout === true
        };
        this.quizMode = mode;
        const saved = !restart && this.quizDrafts[mode];
        this.answers = saved ? JSON.parse(JSON.stringify(saved.answers)) : {};
        this.quizShowSoldout = saved?.includeSoldout === true;
        this.quizStage = saved?.stage || 'core'; this.editing = saved?.editing || false;
        this.wasResults = saved?.wasResults || false; this.hasStarted = !!saved;
        this.questions = questionsFor(this.allQuestions, this.quizMode, this.quizStage);
        this.step = Math.max(0, this.questions.findIndex(q => q.id === saved?.questionId));
      }
      if (restart || !this.hasStarted) {
        this.answers = {}; this.step = 0; this.editing = false; this.wasResults = false; this.ignoredAnswers = [];
        this.quizShowSoldout = false; this.quizShown = QUIZ_BATCH_SIZE; this.quizResultsKey = '';
        this.quizStage = 'core'; this.questions = questionsFor(this.allQuestions, this.quizMode);
        delete this.quizDrafts[mode];
      }
      this.hasStarted = true;
      this.updateStartButtons();
      const returningResults = this.wasResults;
      if (returningResults && this.products) this.renderResults();
      else this.renderQuestion();
      this.scrollToMain();
      this.ensureData().then(() => {
        if (action !== this.actionVersion || !this.isConnected) return;
        if (returningResults && this.view === 'results') this.renderResults();
      }).catch(() => {});
    }
    refineQuiz() {
      this.actionVersion++; this.quizStage = 'refine'; this.editing = false; this.step = 0;
      this.questions = questionsFor(this.allQuestions, this.quizMode, 'refine');
      if (!this.questions.length) return;
      this.renderQuestion(); this.scrollToMain();
    }
    updateProgress() {
      const total = this.questions.length || (this.quizMode === 'long' ? 10 : 4);
      const prefix = this.quizStage === 'refine' ? 'Finjustering ' : 'Fråga ';
      const text = this.main?.querySelector('[data-pdf-progress-text]');
      if (text) text.textContent = prefix + (this.step + 1) + (this.products ? ' av ' : ' av upp till ') + total;
      const bar = this.main?.querySelector('[data-pdf-progress]');
      const pct = Math.round(this.step / total * 100);
      if (bar) { bar.style.width = pct + '%'; bar.parentElement.setAttribute('aria-valuenow', String(pct)); }
      const remaining = this.main?.querySelector('[data-pdf-remaining]');
      if (remaining) remaining.textContent = this.step === total - 1
        ? 'Sista frågan – sedan ser du dina förslag.'
        : (total - this.step - 1) + (this.products ? ' frågor kvar efter den här.' : ' möjliga frågor kvar. Du kan fortsätta svara medan sortimentet läses.');
    }
    renderProfilePreview() {
      const box = el('div', 'pdf-profile-preview');
      const selections = [];
      (this.answers.family || []).forEach(id => { const group = GROUPS.find(g => g.id === id); if (group) selections.push(group.label); });
      (this.answers.occasions || []).forEach(value => selections.push(value));
      const projection = this.allQuestions.find(q => q.id === 'projection')?.options.find(o => o.value === this.answers.projection);
      if (projection) selections.push(projection.label);
      box.append(el('p', 'pdf-eyebrow', selections.length ? 'DIN DOFTPROFIL TAR FORM' : 'EN DOFT SOM BÖRJAR MED DIG'));
      box.append(el('p', '', selections.length ? selections.slice(0, 4).join(' · ') : 'Det finns inga rätt eller fel svar. Du kan alltid ändra dig.'));
      return box;
    }
    renderQuestion(focus = true) {
      const q = this.questions[this.step];
      if (!q) return;
      this.view = 'quiz'; this.wasResults = false;
      const wrap = el('div', 'pdf-quiz');
      const top = el('div', 'pdf-quiz-top');
      top.append(button('Till startsidan', () => this.home(), 'pdf-link-button'));
      const modeLabel = el('span', 'pdf-mode-label', this.quizStage === 'refine' ? 'FINJUSTERA' : this.quizMode === 'long' ? 'LÅNGT TEST' : 'SNABBT TEST');
      top.append(modeLabel);
      const progressText = el('span', 'pdf-progress-text'); progressText.dataset.pdfProgressText = ''; top.append(progressText);
      const track = el('div', 'pdf-progress'); track.setAttribute('role', 'progressbar'); track.setAttribute('aria-label', 'Framsteg i testet'); track.setAttribute('aria-valuemin', '0'); track.setAttribute('aria-valuemax', '100');
      const bar = el('span'); bar.dataset.pdfProgress = ''; track.append(bar);
      const title = this.heading(q.title); title.id = 'pdf-question-' + this.cfg.section_id;
      const intro = el('p', 'pdf-intro', q.text);
      const remaining = el('p', 'pdf-remaining'); remaining.dataset.pdfRemaining = '';
      const grid = el('div', 'pdf-options' + (q.options.some(o => o.image) ? ' pdf-options--images' : '') + (q.searchable ? ' pdf-options--notes' : ''));
      grid.setAttribute('role', 'group'); grid.setAttribute('aria-labelledby', title.id);
      this.optionGrid = grid;
      let query = null;
      if (q.searchable && !q.loading) {
        const label = el('label', 'pdf-input-label', 'Sök noter');
        query = el('input', 'pdf-input'); query.type = 'search'; query.placeholder = 'Sök till exempel en blomma, frukt eller krydda'; query.autocomplete = 'off';
        query.addEventListener('input', () => this.renderOptions(q, grid, query.value));
        label.append(query); wrap.append(label); // Flyttas till rätt plats nedan.
      }
      const feedback = el('p', 'pdf-choice-feedback'); feedback.dataset.pdfChoiceFeedback = ''; feedback.setAttribute('role', 'status');
      const actions = el('div', 'pdf-quiz-actions');
      if (this.quizStage === 'refine') top.append(button('Visa resultat nu', () => this.finishQuiz(), 'pdf-link-button'));
      if (this.step > 0) actions.append(button('Tillbaka', () => { this.step--; this.renderQuestion(); this.scrollToMain(); }, 'pdf-btn pdf-btn--secondary'));
      const skip = button(q.id === 'avoid' ? 'Inget särskilt' : 'Jag vet inte / hoppa över', () => { if (this.advancing) return; delete this.answers[q.id]; this.nextQuestion(); }, 'pdf-link-button');
      const next = button(this.editing ? 'Uppdatera mina förslag' : this.step === this.questions.length - 1 && this.products ? 'Visa mina bästa förslag' : 'Fortsätt', () => this.nextQuestion());
      next.dataset.pdfNext = '';
      next.disabled = !!q.loading || !this.hasAnswer(q);
      actions.append(skip, next);
      wrap.replaceChildren(top, track, this.renderProfilePreview(), title, intro);
      if (query) { const label = el('label', 'pdf-input-label', 'Sök noter'); label.append(query); wrap.append(label); }
      wrap.append(grid, feedback, remaining, actions);
      this.main.replaceChildren(wrap);
      if (q.loading) grid.replaceChildren(this.loadingPanel());
      else this.renderOptions(q, grid, '');
      this.updateProgress();
      if (q.loading) this.updateLoadState();
      if (focus) { this.focusTitle(); this.announce(q.title); }
    }
    hasAnswer(q) { return q.max ? (this.answers[q.id] || []).length > 0 : this.answers[q.id] !== undefined; }
    renderOptions(q, grid, query) {
      grid.replaceChildren();
      const selected = q.max ? (this.answers[q.id] || []) : [this.answers[q.id]];
      let options = q.options;
      if (q.searchable) {
        const text = norm(query);
        options = q.options.filter(o => selected.includes(o.value) || norm(o.label).includes(text)).slice(0, 36);
        // Valda noter ska kunna avmarkeras även när de ligger längre ned i listan.
        selected.forEach(value => { if (!options.some(o => o.value === value)) { const o = q.options.find(v => v.value === value); if (o) options.unshift(o); } });
      }
      if (!options.length) grid.append(el('p', 'pdf-muted', 'Ingen registrerad not matchar sökningen.'));
      options.forEach((option, index) => {
        const label = el('label', 'pdf-option');
        const input = el('input', 'pdf-choice-input'); input.type = q.max ? 'checkbox' : 'radio'; input.name = 'pdf-' + this.cfg.section_id + '-' + q.id;
        input.value = option.value; input.checked = selected.includes(option.value);
        input.disabled = !!q.max && selected.length >= q.max && !input.checked;
        const content = el('span', 'pdf-option-inner');
        if (option.image) { const media = el('span', 'pdf-option-image'); media.append(this.categoryImage(option.image, index)); content.append(media); }
        const copy = el('span', 'pdf-option-copy');
        const labelText = el('span', 'pdf-option-label', option.label);
        labelText.id = 'pdf-option-' + this.cfg.section_id + '-' + q.id + '-' + index;
        input.setAttribute('aria-labelledby', labelText.id);
        copy.append(labelText);
        if (option.desc) {
          const desc = el('span', 'pdf-option-desc', option.desc); desc.id = labelText.id + '-desc';
          input.setAttribute('aria-describedby', desc.id); copy.append(desc);
        }
        const check = el('span', 'pdf-option-check'); check.setAttribute('aria-hidden', 'true');
        copy.append(check); content.append(copy);
        label.append(input, content); grid.append(label);
        input.addEventListener('change', () => {
          if (q.max) {
            let list = (this.answers[q.id] || []).filter(v => v !== option.value);
            if (input.checked && list.length < q.max) list.push(option.value);
            this.answers[q.id] = list;
            grid.querySelectorAll('input').forEach(n => { n.disabled = list.length >= q.max && !n.checked; });
          } else this.answers[q.id] = option.value;
          const next = this.main.querySelector('[data-pdf-next]'); if (next) next.disabled = !this.hasAnswer(q);
          const feedback = this.main.querySelector('[data-pdf-choice-feedback]');
          if (feedback) feedback.textContent = q.max ? (this.answers[q.id] || []).length + ' av högst ' + q.max + ' valda. Fortsätt när du är klar.' : option.label + ' – ditt val är sparat.';
          const preview = this.main.querySelector('.pdf-profile-preview'); if (preview) preview.replaceWith(this.renderProfilePreview());
        });
      });
      if (q.searchable && q.options.length > options.length) grid.append(el('p', 'pdf-note-hint', 'Skriv i sökfältet för att hitta fler noter i hela listan.'));
    }
    nextQuestion() {
      if (this.advancing) return;
      // Frågebyte väntar inte på nätverket. Full katalog krävs först för resultatet.
      if (this.editing || this.step >= this.questions.length - 1) {
        this.editing = false; this.finishQuiz(); return;
      }
      this.step++; this.renderQuestion(); this.scrollToMain();
    }
    finishQuiz(force = false) {
      if (this.finishPromise && !force && this.view === 'results-loading') return this.finishPromise;
      const action = ++this.actionVersion;
      if (this.products && !force && Date.now() - this.loadedAt < TTL) {
        this.renderResults(); this.scrollToMain(); return Promise.resolve();
      }
      this.view = 'results-loading'; this.wasResults = false;
      const wrap = el('div', 'pdf-results-loading');
      wrap.append(this.heading('Dina svar är klara'), this.loadingPanel(true),
        button('Ändra mina svar', () => {
          this.actionVersion++; this.advancing = false; this.finishPromise = null;
          this.quizStage = 'core'; this.questions = questionsFor(this.allQuestions, this.quizMode);
          this.step = 0; this.editing = false; this.renderQuestion(); this.scrollToMain();
        }, 'pdf-link-button'));
      this.main.replaceChildren(wrap); this.updateLoadState(); this.focusTitle(); this.scrollToMain();
      const promise = this.ensureData(force).then(() => {
        if (action !== this.actionVersion || this.view !== 'results-loading' || !this.isConnected) return;
        this.renderResults();
      }).catch(() => {
        // Felet och återförsöket visas nära kunden. Svaren behålls.
      }).finally(() => { if (this.finishPromise === promise) this.finishPromise = null; });
      this.finishPromise = promise;
      return promise;
    }
    home() {
      this.actionVersion++; this.finishPromise = null; this.advancing = false;
      this.view = 'home'; this.setStatus('');
      this.main.replaceChildren();
      this.querySelector('[data-pdf-start]')?.focus({ preventScroll: true });
      this.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
    editAnswer(id) {
      this.actionVersion++; this.finishPromise = null; this.advancing = false;
      const question = this.allQuestions.find(q => q.id === id);
      this.quizStage = this.quizMode !== 'long' && question?.optional ? 'refine' : 'core';
      this.questions = questionsFor(this.allQuestions, this.quizMode, this.quizStage);
      const step = this.questions.findIndex(q => q.id === id);
      if (step < 0) return;
      this.step = step; this.editing = true; this.renderQuestion(); this.scrollToMain();
    }
    renderSummary() {
      const summary = el('div', 'pdf-answer-summary');
      this.allQuestions.forEach(q => {
        const valuesChosen = q.max ? (this.answers[q.id] || []) : this.answers[q.id] !== undefined ? [this.answers[q.id]] : [];
        if (!valuesChosen.length) return;
        const names = valuesChosen.map(value => q.options.find(o => o.value === value)?.label || value);
        const chip = button(names.join(' + ') + ' · Ändra', () => this.editAnswer(q.id), 'pdf-answer-chip');
        chip.setAttribute('aria-label', 'Ändra svaret: ' + names.join(', ')); summary.append(chip);
      });
      return summary;
    }
    setQuizShowSoldout(value) {
      if (this.view !== 'results') return;
      this.quizShowSoldout = value === true;
      this.renderResults(false);
      this.main.querySelector('[data-pdf-quiz-stock]')?.focus({ preventScroll: true });
      // Vanliga kryss kostar inget nätverksanrop. Läs om data först när femminuterscachen har löpt ut.
      if (this.products && Date.now() - this.loadedAt >= TTL) {
        const action = ++this.actionVersion;
        this.ensureData().then(() => {
          if (action !== this.actionVersion || this.view !== 'results' || !this.isConnected) return;
          const restoreFocus = document.activeElement === this.main.querySelector('[data-pdf-quiz-stock]');
          this.renderResults(false);
          if (restoreFocus) this.main.querySelector('[data-pdf-quiz-stock]')?.focus({ preventScroll: true });
        }).catch(() => {}); // Befintligt statusfält visar felet och erbjuder återförsök.
      }
    }
    renderQuizStockChoice() {
      const box = el('div', 'pdf-result-stock');
      const label = el('label', 'pdf-stock-choice pdf-stock-choice--quiz');
      const checkbox = el('input'); checkbox.type = 'checkbox'; checkbox.checked = this.quizShowSoldout === true;
      checkbox.dataset.pdfQuizStock = ''; checkbox.id = 'pdf-quiz-stock-' + this.cfg.section_id;
      label.htmlFor = checkbox.id;
      checkbox.setAttribute('aria-controls', 'pdf-quiz-results-' + this.cfg.section_id + ' pdf-quiz-extra-' + this.cfg.section_id);
      const copy = el('span', 'pdf-stock-choice-copy');
      const title = el('span', 'pdf-stock-choice-title', 'Visa även slutsålda parfymer');
      title.id = checkbox.id + '-label'; checkbox.setAttribute('aria-labelledby', title.id);
      const hint = el('span', 'pdf-stock-choice-hint', 'Inkludera dofter som passar dina svar men inte går att köpa som stor flaska just nu.');
      hint.id = checkbox.id + '-hint'; checkbox.setAttribute('aria-describedby', hint.id);
      copy.append(title, hint); label.append(checkbox, copy); box.append(label);
      checkbox.addEventListener('change', () => this.setQuizShowSoldout(checkbox.checked));
      const mode = this.quizShowSoldout === true
        ? 'Visar de främsta förslagen efter profilmatchning, oavsett lagerstatus. Du kan välja att se fler. Matchningsprocenten påverkas inte av lagret.'
        : 'Visar bara parfymer med en köpbar stor flaska.';
      box.append(el('p', 'pdf-stock-mode', mode));
      return box;
    }
    renderResults(focus = true) {
      if (!this.products) { this.finishQuiz(); return; }
      this.view = 'results'; this.wasResults = true;
      this.results = quizRecommendations(this.products || [], this.answers, { includeSoldout: this.quizShowSoldout === true });
      // Bevara utökningen vid omritning av exakt samma resultat, men återställ efter ändrade val.
      const resultKey = JSON.stringify([this.quizMode, this.answers, this.quizShowSoldout === true,
        this.results.map(item => [item.product.id, item.product.available, item.product.price, item.score, item.coverage])]);
      this.quizShown = resultKey === this.quizResultsKey
        ? Math.max(QUIZ_BATCH_SIZE, Math.min(this.quizShown || QUIZ_BATCH_SIZE, this.results.length)) : QUIZ_BATCH_SIZE;
      this.quizResultsKey = resultKey;
      const wrap = el('div', 'pdf-results');
      wrap.append(el('p', 'pdf-eyebrow', 'DIN PERSONLIGA DOFTGUIDE'), this.heading(this.results.length ? 'Här börjar din nästa doft' : 'Ingen tillräcklig match just nu'));
      const first = this.results[0];
      const tied = first && first.possible && this.results[1] && Math.abs(first.score - this.results[1].score) < 0.000001;
      const intro = !first ? 'Vi hittade inte en tillräcklig match inom dina val.' : !first.possible ? 'Du har hoppat över doftönskemålen. Detta är förslag att utforska, inte en personlig rangordning.' : first.percentage === null ? 'Här är de närmaste förslagen. Fler svar eller bättre produktdata behövs innan vi visar en matchningsprocent.' : tied ? 'De högst rankade dofterna matchar lika bra. Vi visar samma poäng – ingen skillnad är påhittad.' : first.label === 'Stark profilmatch' ? (!first.product.available ? 'Den bästa profilmatchningen är slutsåld som stor flaska. Jämför först de tre främsta förslagen; fler relevanta alternativ kan visas nedanför.' : 'Börja med vårt förstaval och jämför med alternativen. Du ser först de tre främsta matchningarna och kan själv välja att utforska fler.') : 'Här är de närmaste alternativen. Ingen är en stark match med alla dina önskemål ännu.';
      wrap.append(el('p', 'pdf-intro', intro), this.renderSummary());
      if (this.ignoredAnswers.length) {
        const labels = { audience: 'avdelning', sweetness: 'sötma', projection: 'doftspridning', longevity: 'hållbarhet', occasions: 'tillfälle', seasons: 'årstid', notes: 'noter', avoid: 'bortval' };
        wrap.append(el('p', 'pdf-warning', 'Produktuppgifter saknas för ' + this.ignoredAnswers.map(id => labels[id] || id).join(', ') + '. De svaren kunde inte användas i jämförelsen.'));
      }
      if (this.answers.sweetness === 'high' && (this.answers.avoid || []).includes('sweet')) wrap.append(el('p', 'pdf-warning', 'Du har både valt sötma och valt att undvika tydlig sötma. Ändra ett av svaren för mer relevanta förslag.'));
      const toolbar = el('div', 'pdf-result-toolbar');
      const count = el('span', 'pdf-muted'); count.dataset.pdfQuizCount = ''; toolbar.append(count);
      toolbar.append(button('Ändra svar', () => { this.quizStage = 'core'; this.questions = questionsFor(this.allQuestions, this.quizMode); this.step = 0; this.editing = false; this.renderQuestion(); this.scrollToMain(); }, 'pdf-link-button'), button('Börja om', () => this.startQuiz(true), 'pdf-link-button'));
      wrap.append(toolbar, this.renderQuizStockChoice());
      if (this.results.length) {
        const notice = el('div', 'pdf-stock-notice'); notice.dataset.pdfQuizStockNotice = '';
        notice.hidden = !this.results.slice(0, this.quizShown).every(item => !item.product.available);
        notice.append(el('p', '', 'Alla visade förslag är slutsålda som stora flaskor. Du kan byta till köpbara förslag utan att ändra dina svar.'),
          button('Visa bara köpbara förslag', () => this.setQuizShowSoldout(false), 'pdf-link-button'));
        wrap.append(notice);
      }
      if (this.quizMode === 'quick' && this.answers.budget === undefined) {
        const budgetNote = el('div', 'pdf-budget-reminder');
        budgetNote.append(el('span', '', 'Ingen budget vald i snabbtestet.'), button('Lägg till budget', () => this.editAnswer('budget'), 'pdf-link-button'));
        wrap.append(budgetNote);
      }
      if (this.results.length && this.cfg.show_samples !== false) {
        const sampleIntro = el('aside', 'pdf-sample-intro');
        sampleIntro.append(el('h3', '', 'Osäker? Börja med ett doftprov.'), el('p', '', 'Prova 3 ml hemma innan du väljer en större flaska. Där vi hittar samma parfym som sample får du ett eget val direkt på kortet.'));
        wrap.append(sampleIntro);
      }
      const grid = el('div', 'pdf-product-grid pdf-product-grid--top3');
      grid.dataset.pdfResultsGrid = ''; grid.id = 'pdf-quiz-results-' + this.cfg.section_id; wrap.append(grid);
      const extraSection = el('section', 'pdf-extra-results'); extraSection.dataset.pdfExtraSection = ''; extraSection.hidden = true;
      const extraTitle = el('h3', 'pdf-extra-title', 'Fler alternativ för dig'); extraTitle.id = 'pdf-extra-title-' + this.cfg.section_id;
      extraSection.setAttribute('aria-labelledby', extraTitle.id);
      extraSection.append(extraTitle, el('p', 'pdf-extra-intro', 'Fortsatt sorterade efter matchning. Dina främsta förslag ligger kvar ovanför.'));
      const extraGrid = el('div', 'pdf-product-grid pdf-product-grid--extra'); extraGrid.dataset.pdfExtraGrid = '';
      extraGrid.id = 'pdf-quiz-extra-' + this.cfg.section_id; extraSection.append(extraGrid); wrap.append(extraSection);
      const moreBox = el('div', 'pdf-quiz-more'); moreBox.dataset.pdfQuizMoreBox = ''; moreBox.hidden = true;
      moreBox.append(el('h3', '', 'Vill du utforska fler dofter?'),
        el('p', '', 'Se fler alternativ utifrån dina svar. Dina främsta matchningar visas ovan.'));
      const more = button('Visa fler matchningar', () => this.showMoreQuizResults(), 'pdf-btn pdf-btn--secondary');
      more.dataset.pdfQuizMore = ''; more.setAttribute('aria-controls', extraGrid.id);
      const remaining = el('p', 'pdf-more-remaining'); remaining.dataset.pdfQuizRemaining = '';
      remaining.id = 'pdf-more-remaining-' + this.cfg.section_id; more.setAttribute('aria-describedby', remaining.id);
      moreBox.append(more, remaining); wrap.append(moreBox);
      const endNote = el('p', 'pdf-more-end'); endNote.dataset.pdfQuizEnd = ''; endNote.hidden = true; wrap.append(endNote);
      if (!this.results.length) {
        const empty = el('div', 'pdf-empty');
        const soldoutMatches = !this.quizShowSoldout && topRecommendations(this.products || [], this.answers, { includeSoldout: true }).length > 0;
        if (soldoutMatches) {
          empty.append(el('h3', '', 'Inga köpbara förslag matchar dina val just nu.'),
            el('p', '', 'Det finns slutsålda dofter som passar dina svar. Du kan inkludera dem eller ändra dina önskemål.'));
          const reveal = button('Visa matchningar som är slutsålda', () => this.setQuizShowSoldout(true), 'pdf-btn pdf-btn--secondary');
          reveal.dataset.pdfRevealSoldout = ''; empty.append(reveal);
        } else {
          empty.append(el('h3', '', 'Vi ändrar inte din budget eller dina bortval åt dig.'),
            el('p', '', 'Ändra en doftriktning, budgeten eller det du vill undvika. Produkter utan tillräckliga uppgifter får ingen påhittad matchning.'));
        }
        wrap.append(empty);
      }
      const optionalCount = this.quizMode === 'quick' ? this.allQuestions.filter(q => q.optional).length : 0;
      if (optionalCount) {
        const refine = el('div', 'pdf-refine');
        refine.append(el('h3', '', 'Vill du göra valet mer personligt?'), el('p', '', 'Lägg till budget, sådant du vill undvika och fler doftönskemål i upp till ' + optionalCount + ' frivilliga frågor. Dina tidigare svar följer med.'), button('Finjustera mina förslag', () => this.refineQuiz(), 'pdf-btn pdf-btn--secondary'));
        wrap.append(refine);
      }
      const note = el('details', 'pdf-explanation'); note.id = 'pdf-score-help-' + this.cfg.section_id;
      note.append(el('summary', '', 'Vad betyder matchningsprocenten?'), el('p', '', 'Procenten visar hur stor andel av dina viktade doftönskemål som stöds av produktuppgifterna. Det är inte sannolikheten att du kommer att gilla parfymen. Doftprofil väger 36, noter 22 och övriga doftönskemål 10 vardera. Endast besvarade önskemål räknas.'));
      note.append(el('p', '', 'Budget, avdelning och bortval avgränsar urvalet men ger inga extra procent. Saknade uppgifter ger inga matchpoäng. Procent visas först med minst tre bedömda doftönskemål och minst 60 % datatäckning. Lika poäng visas som lika, och utan doftönskemål utses ingen personlig vinnare.'));
      note.append(el('p', '', 'Lagerstatus ger varken extra poäng eller poängavdrag. Som standard visas bara köpbara stora flaskor. Väljer du att inkludera slutsålda rangordnas de med samma poängsystem. Vid lika poäng och lika datatäckning visas en köpbar produkt först, utan att procenten ändras.'));
      note.append(el('p', '', 'Du ser först upp till tre förslag. Visa fler lägger till upp till tre åt gången, högst nio totalt. Extra förslag kräver minst 50 % av möjlig intern matchpoäng, minst 60 % datatäckning och stöd för minst en vald doftriktning. Det är urvalsregler, inte en garanti för att du gillar doften. Utan poängsatta doftönskemål visas inga extra förslag.'));
      note.append(el('p', '', 'Pris och köpbarhet kontrolleras på produktsidan och i kassan. Produktdata återanvänds kortvarigt och kan ändras. En stor flaska och dess sample kan ha olika lagerstatus. Samples är separata köp; ingen rabatt eller gratisvara skapas av testet.'));
      wrap.append(note);
      this.main.replaceChildren(wrap); this.renderProductGrid(); if (focus) this.focusTitle();
      const visible = this.results.slice(0, this.quizShown);
      const soldoutCount = visible.filter(item => !item.product.available).length;
      this.announce(visible.length + ' utvalda förslag visas.' + (this.quizShowSoldout ? ' Slutsålda ingår: ' + soldoutCount + '.' : ' Endast köpbara stora flaskor visas.'));
      if (this.cfg.show_samples !== false && this.results.length) this.ensureSamples().catch(() => {});
    }
    productCard(item, index) {
      const p = item.product;
      const quiz = this.view === 'results';
      const card = el('article', 'pdf-product' + (!p.available ? ' pdf-product--soldout' : '') + (quiz && index === 0 ? ' pdf-product--first' : ''));
      card.dataset.pdfProductId = String(p.id);
      if (quiz) {
        const tied = item.possible && this.results.some((other, i) => i !== index && Math.abs(other.score - item.score) < 0.000001 && Math.abs(other.score - this.results[0].score) < 0.000001);
        let label = !item.possible ? 'Förslag att utforska' : tied ? 'Delad högsta matchning' : index === 0 && item.label === 'Stark profilmatch' && item.percentage !== null ? (p.available ? 'Vår rekommendation' : 'Bästa profilmatch') : index === 0 ? 'Närmast dina svar' : 'Alternativ ' + (index + 1);
        if (!p.available) label += ' – slutsåld';
        card.append(el('div', 'pdf-rank-banner', (index + 1) + ' · ' + label));
      }
      const media = el('a', 'pdf-product-media'); media.href = safeURL(p.url) || '#'; media.setAttribute('aria-label', p.title);
      if (p.image) {
        const image = imageNode(p.image, p.image_alt || p.title);
        const large = safeURL(p.image_large, true), small = safeURL(p.image, true);
        if (large && small) image.srcset = small + ' 360w, ' + large + ' 640w';
        image.sizes = quiz && index >= QUIZ_BATCH_SIZE
          ? '(min-width: 990px) 360px, (min-width: 750px) 45vw, 90vw'
          : '(min-width: 990px) 320px, (min-width: 600px) 45vw, 90vw';
        if (index === 0) { image.loading = 'eager'; image.setAttribute('fetchpriority', 'high'); }
        media.append(image);
      } else media.append(el('span', 'pdf-image-fallback', 'ParfymDupe'));
      if (!p.available) media.append(el('span', 'pdf-badge pdf-badge--muted', 'Stor flaska slutsåld'));
      else if (p.compare > p.price && p.compare > 0) media.append(el('span', 'pdf-badge', '−' + Math.round((p.compare - p.price) / p.compare * 100) + ' %'));
      card.append(media);
      const body = el('div', 'pdf-product-body');
      if (quiz) {
        const match = el('div', 'pdf-match' + (item.percentage === null ? ' pdf-match--unscored' : ''));
        match.append(el('strong', 'pdf-match-number', item.percentage !== null ? item.percentage + ' %' : 'Din profilmatch'));
        match.append(el('span', 'pdf-match-caption', item.percentage !== null ? 'matchning med dina svar' : 'För få bedömda uppgifter för procent'));
        if (item.percentage !== null) { const meter = el('div', 'pdf-score-meter'); const fill = el('span'); fill.style.width = item.percentage + '%'; meter.append(fill); meter.setAttribute('aria-hidden', 'true'); match.append(meter); }
        body.append(match);
      }
      if (item.label) body.append(el('p', 'pdf-match-label', item.label));
      if (p.vendor) body.append(el('p', 'pdf-product-vendor', p.vendor));
      const title = el('h3', 'pdf-product-title'); const link = el('a', '', p.title); link.href = safeURL(p.url) || '#'; title.append(link); body.append(title);
      if (p.variant_title && p.variant_title !== 'Default Title') body.append(el('p', 'pdf-muted pdf-variant', p.variant_title));
      if (p.originalFragrances.length) {
        const brand = p.originalBrands.join(' / '), fragrance = p.originalFragrances.join(' / ');
        const full = brand && !norm(fragrance).includes(norm(brand)) ? brand + ' – ' + fragrance : fragrance;
        body.append(el('p', 'pdf-original', 'Inspirerad av ' + full));
      }
      if (item.reasons.length) {
        const list = el('ul', 'pdf-reasons'); item.reasons.forEach(r => list.append(el('li', '', r))); body.append(list);
      }
      const specs = el('div', 'pdf-specs');
      const longevity = values(p.meta.longevity).join(' / ');
      if (longevity || p.hours !== null) specs.append(el('span', '', longevity ? 'Hållbarhet: ' + longevity : 'Hållbarhetsfilter: ' + p.hours + ' timmar'));
      if (p.projection !== null) specs.append(el('span', '', 'Doftspridning: nivå ' + p.projection));
      if (specs.childNodes.length) body.append(specs);
      if (p.profiles.length || p.notes.length) {
        const details = el('details', 'pdf-details'); details.append(el('summary', '', 'Doftprofil & noter'));
        const add = (name, list) => { if (list.length) { const row = el('p'); row.append(el('strong', '', name + ': '), document.createTextNode(list.join(', '))); details.append(row); } };
        add('Doftprofil', p.profiles); add('Toppnoter', values(p.meta.top)); add('Hjärtnoter', values(p.meta.heart)); add('Basnoter', values(p.meta.base));
        if (!values(p.meta.top).length && !values(p.meta.heart).length && !values(p.meta.base).length) add('Registrerade noter', p.notes);
        body.append(details);
      }
      if (quiz && item.breakdown?.length) {
        const details = el('details', 'pdf-details pdf-score-details'); details.append(el('summary', '', 'Se hur poängen räknas'));
        item.breakdown.forEach(row => details.append(el('p', '', row.label + ': ' + (row.known ? (Math.round(row.earned * 10) / 10) + ' av ' + row.weight + ' poäng' : 'uppgift saknas – 0 av ' + row.weight + ' poäng'))));
        details.append(el('p', '', 'Matchning med registrerade egenskaper, inte en garanti för din upplevelse.')); body.append(details);
      }
      if (item.unknown.length) body.append(el('p', 'pdf-data-note', 'Uppgift saknas för: ' + item.unknown.join(', ') + '.'));
      const price = el('div', 'pdf-price'); price.append(el('strong', '', p.price_text || 'Se aktuellt pris'));
      if (p.compare > p.price && p.compare_text) price.append(el('s', '', p.compare_text));
      body.append(price);
      const cta = el('a', 'pdf-btn pdf-product-cta' + (!p.available ? ' pdf-btn--secondary' : ''), p.available ? 'Se stora flaskan' : 'Se parfymen'); cta.href = safeURL(p.url) || '#'; body.append(cta);
      if (this.cfg.show_samples !== false) { const sampleSlot = el('div', 'pdf-sample-slot'); sampleSlot.dataset.pdfSampleFor = String(p.id); this.renderSampleSlot(sampleSlot, p); body.append(sampleSlot); }
      card.append(body); return card;
    }
    renderProductGrid() {
      const grid = this.main.querySelector('[data-pdf-results-grid]'); if (!grid) return;
      const fragment = document.createDocumentFragment();
      this.results.slice(0, this.view === 'results' ? QUIZ_BATCH_SIZE : this.shown).forEach((item, i) => fragment.append(this.productCard(item, i)));
      grid.replaceChildren(fragment);
      if (this.view === 'results') {
        const extraGrid = this.main.querySelector('[data-pdf-extra-grid]');
        if (extraGrid) {
          const extra = document.createDocumentFragment();
          this.results.slice(QUIZ_BATCH_SIZE, this.quizShown).forEach((item, i) => extra.append(this.productCard(item, i + QUIZ_BATCH_SIZE)));
          extraGrid.replaceChildren(extra);
        }
        this.updateQuizMoreControls();
      } else {
        const more = this.main.querySelector('[data-pdf-more]'); if (more) more.hidden = this.shown >= this.results.length;
      }
    }
    updateQuizMoreControls() {
      if (this.view !== 'results') return;
      const total = Math.min(QUIZ_MAX_RESULTS, this.results.length);
      const shown = Math.min(this.quizShown || QUIZ_BATCH_SIZE, total);
      const remaining = total - shown;
      const count = this.main.querySelector('[data-pdf-quiz-count]');
      if (count) count.textContent = total > QUIZ_BATCH_SIZE
        ? shown + ' av ' + total + ' utvalda förslag visas'
        : shown + (shown === 1 ? ' utvalt förslag' : ' utvalda förslag');
      const section = this.main.querySelector('[data-pdf-extra-section]'); if (section) section.hidden = shown <= QUIZ_BATCH_SIZE;
      const moreBox = this.main.querySelector('[data-pdf-quiz-more-box]'); if (moreBox) moreBox.hidden = remaining <= 0;
      const hint = this.main.querySelector('[data-pdf-quiz-remaining]');
      if (hint) hint.textContent = 'Nästa klick visar ' + Math.min(QUIZ_BATCH_SIZE, remaining) + (remaining === 1 ? ' parfym till.' : ' parfymer till.') + ' Högst nio utvalda förslag totalt.';
      const end = this.main.querySelector('[data-pdf-quiz-end]');
      if (end) { end.hidden = shown <= QUIZ_BATCH_SIZE || remaining > 0; end.textContent = 'Du har sett alla ' + shown + ' utvalda förslag i den här listan. Ändra dina svar för att utforska en annan doftprofil.'; }
      const notice = this.main.querySelector('[data-pdf-quiz-stock-notice]');
      if (notice) notice.hidden = !shown || !this.results.slice(0, shown).every(item => !item.product.available);
    }
    showMoreQuizResults() {
      if (this.view !== 'results') return;
      const grid = this.main.querySelector('[data-pdf-extra-grid]');
      if (!grid) return;
      const from = Math.min(this.quizShown || QUIZ_BATCH_SIZE, this.results.length);
      const to = Math.min(from + QUIZ_BATCH_SIZE, this.results.length, QUIZ_MAX_RESULTS);
      if (to <= from) return;
      const x = window.scrollX, y = window.scrollY;
      const trigger = this.main.querySelector('[data-pdf-quiz-more]');
      const moveFocus = document.activeElement === trigger;
      const fragment = document.createDocumentFragment();
      let firstNew = null;
      this.results.slice(from, to).forEach((item, i) => {
        const card = this.productCard(item, from + i);
        if (!firstNew) firstNew = card;
        fragment.append(card);
      });
      // Lägg bara till nya kort: huvudrekommendation, öppna detaljer och tidigare kort finns kvar.
      grid.append(fragment); this.quizShown = to; this.updateQuizMoreControls();
      if (moveFocus && firstNew) {
        firstNew.tabIndex = -1;
        firstNew.setAttribute('aria-label', 'Parfymförslag ' + (from + 1) + ': ' + this.results[from].product.title);
        firstNew.focus({ preventScroll: true });
      }
      window.scrollTo({ left: x, top: y, behavior: 'instant' });
      this.announce((to - from) + ' fler förslag har lagts till. ' + to + ' av ' + this.results.length + ' utvalda förslag visas.');
      // Inga fetch/ensureData/ensureSamples här: samma urval och redan inlästa sampledata återanvänds.
      // Bilder för nya kort hämtas först när korten skapats och kan lazy-laddas.
    }
    async startSearch() {
      this.actionVersion++; this.finishPromise = null; this.advancing = false;
      this.view = 'search'; this.searchQuery = this.searchQuery || ''; this.searchBrand = this.searchBrand || ''; this.showSoldout = this.showSoldout || false;
      this.renderSearch(); this.scrollToMain();
      try { await this.ensureData(); if (this.view === 'search') { this.renderSearch(false); if (this.cfg.show_samples !== false) this.ensureSamples().catch(() => {}); } } catch (_) { /* Synligt återförsök i statusfältet. */ }
    }
    renderSearch(focus = true) {
      this.view = 'search';
      const wrap = el('div', 'pdf-search');
      wrap.append(button('Till startsidan', () => this.home(), 'pdf-link-button'), this.heading('Hitta en doft du redan gillar'));
      wrap.append(el('p', 'pdf-intro', 'Sök på en originalparfym, ett originalmärke eller namnet på en parfym hos oss. Sökningen använder våra registrerade inspirationsfält.'));
      const controls = el('div', 'pdf-search-controls');
      const label = el('label', 'pdf-input-label', 'Originalparfym, märke eller produktnamn');
      const input = el('input', 'pdf-input pdf-input--search'); input.type = 'search'; input.autocomplete = 'off'; input.placeholder = 'Vilken parfym gillar du?'; input.value = this.searchQuery || '';
      const searchId = 'pdf-search-results-' + this.cfg.section_id; input.setAttribute('aria-controls', searchId);
      input.addEventListener('input', () => {
        this.searchQuery = input.value; clearTimeout(this.queryTimer);
        this.queryTimer = setTimeout(() => { if (this.view === 'search') this.updateSearchResults(); }, 150);
      });
      label.append(input); controls.append(label);
      const brandLabel = el('label', 'pdf-input-label', 'Inspirerad av märke');
      const select = el('select', 'pdf-input'); select.append(new Option('Alla originalmärken', ''));
      const brands = unique((this.products || []).filter(p => p.eligible).flatMap(p => p.originalBrands)).sort((a, b) => a.localeCompare(b, 'sv'));
      brands.forEach(brand => select.append(new Option(brand, brand))); select.value = this.searchBrand || '';
      select.addEventListener('change', () => { this.searchBrand = select.value; this.updateSearchResults(); });
      brandLabel.append(select); controls.append(brandLabel); wrap.append(controls);
      const stock = el('label', 'pdf-stock-choice'); const checkbox = el('input'); checkbox.type = 'checkbox'; checkbox.checked = this.showSoldout;
      checkbox.addEventListener('change', () => { this.showSoldout = checkbox.checked; this.updateSearchResults(); }); stock.append(checkbox, document.createTextNode('Visa även slutsålda – efter köpbara produkter')); wrap.append(stock);
      const suggestions = el('div', 'pdf-search-suggestions');
      // Endast verkliga originalnamn hämtade ur produktdata, inga hårdkodade kopplingar.
      const names = unique((this.products || []).filter(p => p.eligible && p.available).flatMap(p => p.originalFragrances)).slice(0, 6);
      names.forEach(name => suggestions.append(button(name, () => { input.value = name; this.searchQuery = name; this.updateSearchResults(); }, 'pdf-answer-chip')));
      wrap.append(suggestions);
      const count = el('p', 'pdf-muted'); count.dataset.pdfSearchCount = ''; count.setAttribute('role', 'status'); wrap.append(count);
      const grid = el('div', 'pdf-product-grid'); grid.dataset.pdfResultsGrid = ''; grid.id = searchId; wrap.append(grid);
      const more = button('Visa fler parfymer', () => { this.shown += this.resultLimit; this.renderProductGrid(); }, 'pdf-btn pdf-btn--secondary'); more.dataset.pdfMore = ''; wrap.append(more);
      const empty = el('div', 'pdf-empty'); empty.dataset.pdfSearchEmpty = ''; empty.hidden = true; empty.append(el('p', '', 'Inga produkter matchar sökningen. Prova färre ord, ett annat originalmärke eller gör testet.'), button('Välj parfymtest', () => this.hasStarted ? this.startQuiz() : this.home(), 'pdf-btn pdf-btn--secondary')); wrap.append(empty);
      wrap.append(el('p', 'pdf-data-note', 'Inspirationsuppgifterna är butikens registrerade jämförelser. Ett inspirationsnamn betyder inte att dofterna är identiska.'));
      const hadFocus = this.main.contains(document.activeElement);
      this.main.replaceChildren(wrap); this.updateSearchResults();
      if (focus || hadFocus) input.focus({ preventScroll: true });
    }
    updateSearchResults() {
      if (this.view !== 'search') return;
      if (this.products && Date.now() - this.loadedAt >= TTL) {
        this.ensureData().then(() => { if (this.view === 'search') { this.updateSearchResults(); this.ensureSamples().catch(() => {}); } }).catch(() => {});
        return;
      }
      this.shown = this.resultLimit;
      this.results = this.products ? searchProducts(this.products, this.searchQuery, this.searchBrand, this.showSoldout) : [];
      this.renderProductGrid();
      const count = this.main.querySelector('[data-pdf-search-count]'); if (count) count.textContent = this.products ? this.results.length + ' produkter matchar' : 'Läser sortimentet…';
      const empty = this.main.querySelector('[data-pdf-search-empty]'); if (empty) empty.hidden = !this.products || !!this.results.length;
    }
    async ensureSamples(force = false) {
      if (this.cfg.show_samples === false) return;
      if (this.samplePromise && !force) return this.samplePromise;
      if (!force && this.sampleState === 'ready' && Date.now() - this.samplesAt < TTL) return;
      const href = this.cfg.sample_collection_url;
      if (!href) { this.sampleState = 'disabled'; this.refreshSampleSlots(); return; }
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      url.search = ''; url.searchParams.set('view', 'pd-finder-samples');
      const current = new URLSearchParams(window.location.search);
      ['preview_theme_id', '_fd', 'pb'].forEach(key => { if (current.has(key)) url.searchParams.set(key, current.get(key)); });
      const key = url.href + '|' + this.cfg.currency + '|' + this.cfg.country + '|' + this.cfg.locale;
      const saved = sampleCache.get(key);
      if (!force && saved && Date.now() - saved.at < TTL) { this.sampleRows = saved.rows; this.sampleIndex = makeSampleIndex(saved.rows); this.sampleState = 'ready'; this.samplesAt = saved.at; this.refreshSampleSlots(); return; }
      this.sampleController?.abort(); this.sampleController = new AbortController();
      const controller = this.sampleController;
      const timer = setTimeout(() => controller.abort(), 25000);
      this.sampleState = 'loading'; this.refreshSampleSlots();
      this.samplePromise = (async () => {
        try {
          const read = async page => {
            const pageURL = new URL(url); pageURL.searchParams.set('page', String(page));
            if (force) pageURL.searchParams.set('_pd_refresh', String(Date.now()));
            const response = await fetch(pageURL.href, { credentials: 'same-origin', signal: controller.signal, cache: force ? 'reload' : 'default' });
            if (!response.ok) throw new Error('Samplelistan kunde inte hämtas.');
            const data = JSON.parse(await response.text());
            if (!data || data.format !== 'pd-finder-samples-v1' || data.page !== page || data.page_size !== 250 || !Array.isArray(data.products) || !Number.isInteger(data.total) || data.total < 0 || data.total > 25000 || !Number.isInteger(data.pages) || (data.total > 0 ? data.pages !== Math.ceil(data.total / 250) : ![0, 1].includes(data.pages)) || data.currency !== this.cfg.currency || !data.collection_id || data.products.length !== Math.max(0, Math.min(250, data.total - (page - 1) * 250))) throw new Error('Ogiltig samplelista.');
            return data;
          };
          const first = await read(1), pages = Math.max(1, first.pages), chunks = new Array(pages); chunks[0] = first.products;
          let cursor = 2;
          const worker = async () => { while (cursor <= pages) { const page = cursor++; const data = await read(page); if (data.total !== first.total || data.collection_id !== first.collection_id) throw new Error('Samplelistan ändrades.'); chunks[page - 1] = data.products; } };
          await Promise.all(Array.from({ length: Math.min(2, pages - 1) }, worker));
          const rows = chunks.flat(), ids = new Set();
          rows.forEach(row => { if (!row || !/^\d+$/.test(String(row.id)) || ids.has(String(row.id))) throw new Error('Ofullständig samplelista.'); ids.add(String(row.id)); });
          if (controller.signal.aborted || !this.isConnected || controller !== this.sampleController) return;
          this.sampleRows = rows; this.sampleIndex = makeSampleIndex(rows); this.samplesAt = Date.now(); this.sampleState = 'ready';
          sampleCache.set(key, { rows, at: this.samplesAt }); if (sampleCache.size > 6) sampleCache.delete(sampleCache.keys().next().value);
        } catch (_) { if (this.isConnected && controller === this.sampleController) this.sampleState = 'error'; }
        finally { clearTimeout(timer); if (controller === this.sampleController) { this.samplePromise = null; if (this.isConnected) this.refreshSampleSlots(); } }
      })();
      return this.samplePromise;
    }
    renderSampleSlot(slot, product) {
      slot.replaceChildren();
      const freshIndex = this.sampleState === 'ready' && Date.now() - this.samplesAt < TTL ? this.sampleIndex : null;
      const sample = linkedSample(product, freshIndex);
      if (sample && safeURL(sample.url)) {
        if (!sample.available) { slot.append(el('p', 'pdf-sample-unavailable', !product.available ? '3 ml-provet är också slutsålt.' : '3 ml-provet är slutsålt.')); return; }
        if (!product.available) slot.append(el('p', 'pdf-sample-stock-note', 'Stor flaska slutsåld · 3 ml-doftprov finns att köpa.'));
        const inner = el('div', 'pdf-sample-offer');
        if (sample.image) inner.append(imageNode(sample.image, 'Doftprov 3 ml: ' + sample.title, 'pdf-sample-image'));
        const copy = el('div'); copy.append(el('p', 'pdf-sample-label', 'Börja med 3 ml'), el('p', 'pdf-sample-price', sample.price_text || 'Se aktuellt samplepris'));
        inner.append(copy); slot.append(inner);
        const cta = el('a', 'pdf-btn pdf-btn--secondary pdf-sample-cta' + (!product.available ? ' pdf-sample-cta--primary' : ''), 'Prova 3 ml först'); cta.href = safeURL(sample.url);
        cta.setAttribute('aria-label', 'Prova ' + product.title + ' som 3 ml-sample' + (sample.price_text ? ', ' + sample.price_text : ''));
        slot.append(cta, el('p', 'pdf-data-note', !product.available ? 'Upptäck doften med ett litet prov. Samplet säljs separat och reserverar inte en stor flaska.' : 'Samma parfym i litet format. Separat köp.'));
      } else if (this.sampleState === 'loading' || this.sampleState === 'idle') slot.append(el('p', 'pdf-data-note', 'Kontrollerar om samma doft finns som 3 ml-prov…'));
      else {
        slot.append(el('p', 'pdf-data-note', this.sampleState === 'error' ? 'Samplealternativet kunde inte kontrolleras just nu.' : 'Vi hittade inget säkert kopplat 3 ml-prov för just denna doft.'));
        if (this.sampleState === 'error') slot.append(button('Kontrollera samples igen', () => this.ensureSamples(true), 'pdf-link-button'));
        if (safeURL(this.cfg.sample_collection_url)) { const link = el('a', 'pdf-sample-browse', 'Utforska alla doftprover'); link.href = safeURL(this.cfg.sample_collection_url); slot.append(link); }
      }
    }
    refreshSampleSlots() {
      if (!this.main || this.cfg.show_samples === false) return;
      const byId = new Map((this.results || []).map(item => [String(item.product.id), item.product]));
      this.main.querySelectorAll('[data-pdf-sample-for]').forEach(slot => { const product = byId.get(slot.dataset.pdfSampleFor); if (product) this.renderSampleSlot(slot, product); });
    }
    async diagnostics() {
      const box = this.querySelector('[data-pdf-diagnostic-output]'); if (!box) return;
      box.hidden = false; box.replaceChildren(el('p', '', 'Kontrollerar produktdata…'));
      try {
        await this.ensureData();
        box.replaceChildren(el('h3', '', 'Datakontroll – endast i temaredigeraren'));
        diagnosticRows(this.products).forEach(([label, count, total]) => box.append(el('p', '', label + ': ' + count + ' av ' + total + ' parfymprodukter.')));
        const categoryDetails = el('details'); categoryDetails.append(el('summary', '', 'Kontrollera de 14 doftvalen'));
        const eligible = this.products.filter(p => p.eligible);
        GROUPS.forEach(group => {
          const evidence = eligible.map(p => groupEvidence(p, group));
          categoryDetails.append(el('p', '', group.label + ': ' + evidence.filter(e => e.field === 'profile').length + ' med profilmatch, ' + evidence.filter(e => e.field === 'note').length + ' med enbart notstöd.'));
        });
        categoryDetails.append(el('p', '', 'Ett motiv är en doftriktning, inte nya produktuppgifter. Noll träffar kan betyda att matchande parfymer saknas eller att fältnamn/värden behöver kontrolleras.'));
        box.append(categoryDetails);
        box.append(el('p', '', 'Noll träffar? Kontrollera motsvarande nyckel högst upp i templates/collection.pd-finder-data.liquid. Frågor utan data hoppas över.'));
        if (this.cfg.show_samples !== false) {
          await this.ensureSamples();
          const valid = this.products.filter(p => p.eligible);
          const matches = valid.map(p => linkedSample(p, this.sampleIndex));
          box.append(el('p', '', 'Samplekontroll: ' + this.sampleState + '. ' + matches.filter(Boolean).length + ' av ' + valid.length + ' parfymer har en entydig samplekoppling; ' + matches.filter(v => v?.available).length + ' är köpbara.'));
          box.append(el('p', '', 'Saknad koppling? Koppla rätt sample med produktreferensen custom.sample_product på den stora flaskan. Lika inspiration räknas inte som samma parfym.'));
        }
        const details = el('details'); details.append(el('summary', '', 'Visa fältmappningen')); details.append(el('pre', '', JSON.stringify(this.fields, null, 2))); box.append(details);
      } catch (_) { box.replaceChildren(el('p', '', 'Datakontrollen kunde inte slutföras. Kontrollera meddelandet ovan.')); }
    }
  }
  customElements.define('pd-perfume-finder', PerfumeFinder);
})();
